
import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import ToggleSwitch from '../ToggleSwitch';
import Button from './Button';
import { Tabs, Tab, Box } from '@mui/material';
import { useDropzone } from 'react-dropzone';
import UseToast from '../../UseToast';
import Swal from 'sweetalert2';

import SplashText from './SplashText';

import QRCode from 'qrcode';
import ButtonNavigations from './ButtonNavigations';
import { Typography } from '@mui/material';

import { MuiColorInput } from 'mui-color-input';
import CaptionUploadModal from '../../CaptionUploadModal';
import { useCaptionUpload } from '../../../hooks/useCaptionUpload';
import useFontFamilies from '../../../hooks/useFontFamilies';
const ButtonSettingsForm = () => {
  const navigate = useNavigate();
  const fontOptions = useFontFamilies('option');

  const [leftTopMedia, setLeftTopMedia] = useState(null);
  const [qrLogo, setQrLogo] = useState(null);
  const [btnSound, setBtnSound] = useState(null);
  const [btnPng, setBtnPng] = useState(null);
  const [btnIcon, setBtnIcon] = useState(null);
  const [leftBottomMedia, setLeftBottomMedia] = useState(null);
  const [rightTopMedia, setRightTopMedia] = useState(null);
  const [rightBottomMedia, setRightBottomMedia] = useState(null);
  const [splashVideoMedia, setSplashVideoMedia] = useState(null);
  const [splashVideoMediaTwo, setSplashVideoMediaTwo] = useState(null);
  const [splashVideoMediaThree, setSplashVideoMediaThree] = useState(null);
  const [centerLogoMedia, setCenterLogoMedia] = useState(null);
  const [centerBelowMenuMedia, setCenterBelowMenuMedia] = useState(null);
  const [backMenuMedia, setBackMenuMedia] = useState(null);

  const { showMsgSuccessToast, showErrorToast } = UseToast(); // Use the custom hook
  const [menuBackButton, setMenuBackButton] = useState(false);
  const [buttonColor, setButtonColor] = useState('');
  const [qrText, setQrText] = useState('');
  const [qrCode, setQrCode] = useState('');
  const [isPrimary, setIsPrimary] = useState(false);
  const [splashText, setSplashText] = useState('');
  const [videotime, setVideoTime] = useState(0);
  const [parentMenuName, setParentMenuName] = useState('');
  const [chilmenuName, setChildMenuName] = useState('');
  const [isFrontend, setIsFrontend] = useState(false);
  const [parentMenuID, SetParentMenuID] = useState(null);
  const [linkbtnId, setLinkedBtnId] = useState(null);
  const [corner, setCorner] = useState(null);
  const [menuContent, setMenuContent] = useState('video');
  const [externalweblink, setExternalweblink] = useState('');
  const [menuLevel, setMenuLevel] = useState('');
  const [linkedTrivia, setLinkedTrivia] = useState(false);
  const [mainMeuLinked, setMainMeuLinked] = useState(false);
  const [menuUrl, setMenuUrl] = useState('');

  const [linkedWayfinder, setLinkedWayfinder] = useState(null);

  const { id, userId } = useParams(); // Get the optional client ID from the route

  const [value, setValue] = useState(0);

  // Add separate modal states for each video
  const [modalStates, setModalStates] = useState({
    splashVideo: false,
    splashVideotwo: false,
    splashVideothree: false,
  });

  // Add separate caption file states for each video
  const [captionFiles, setCaptionFiles] = useState({
    splashVideo: null,
    splashVideotwo: null,
    splashVideothree: null,
  });

  // Update the modal handlers
  const openCaptionModal = (videoKey) => {
    setModalStates(prev => ({
      ...prev,
      [videoKey]: true,
    }));
  };

  const closeCaptionModal = (videoKey) => {
    setModalStates(prev => ({
      ...prev,
      [videoKey]: false,
    }));
  };

  const { handleCaptionUpload: uploadCaption } = useCaptionUpload();
  const [captionFile, setCaptionFile] = useState(null);

  // Update the modal call
  const handleCaptionUpload = async (captionFile, convertSrtToVtt, videoKey) => {
    try {
      await uploadCaption(
        captionFile,
        convertSrtToVtt,
        setUploadedUrls,
        videoKey,
        userId
      );
      setCaptionFile(null);
    } catch (error) {
      // Error is already handled in the hook
    }
  };


  const handleTabChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleCaptionFileChange = (videoKey, file) => {
    setCaptionFiles(prev => ({
      ...prev,
      [videoKey]: file,
    }));
  };

  const [uploadingStates, setUploadingStates] = useState({
    leftTop: false,
    leftBottom: false,
    rightTop: false,
    rightBottom: false,
    splashVideo: false,
    splashVideotwo: false,
    splashVideothree: false,
    centerLogoMedia: false,
    centerBelowMenuMedia: false,
    backMenuMedia: false,
    btnSound: false,
    btnPng: false,
    btnIcon: false,
  });
  const [uploadedUrls, setUploadedUrls] = useState({
    leftTop: {
      fileName: '',
      fileUrl: '',
      enabled: false,
      width: 0,
      height: 0,
      disabledPadding: false,
      disabledMargin: false,
    },
    leftBottom: {
      fileName: '',
      fileUrl: '',
      enabled: false,
      width: 0,
      height: 0,
    },
    rightTop: {
      fileName: '',
      fileUrl: '',
      enabled: false,
      width: 0,
      height: 0,
    },
    rightBottom: {
      fileName: '',
      fileUrl: '',
      enabled: false,
      width: 0,
      height: 0,
    },
    splashVideo: {
      fileName: '',
      fileUrl: '',
      enabled: false,
      captionFile: '',
    },
    splashVideotwo: {
      fileName: '',
      fileUrl: '',
      enabled: false,
      captionFile: '',

    },
    splashVideothree: {
      fileName: '',
      fileUrl: '',
      enabled: false,
      captionFile: '',

    },
    centerLogoMedia: {
      fileName: '',
      fileUrl: '',
      enabled: false,
      width: 0,
      height: 0,
    },
    centerBelowMenuMedia: {
      fileName: '',
      fileUrl: '',
      enabled: false,
      width: 0,
      height: 0,
    },
    backMenuMedia: {
      fileName: '',
      fileUrl: '',
      enabled: false,
      width: 0,
      height: 0,
    },
  });

  const [primaryMenuTextsettings, setPrimaryMenuTextSettings] = useState({
    globalSettings: {
      height: 50,
      width: 150,
      font: 'Arial',
      fontColor: '#127E10',
      fontSize: 16,
      shadow: {
        angle: 5,
        size: 10,
        distance: 5,
        alpha: 0.5,
        color: '#FF5733', // Bright orange
      },
      highlight: {
        fontColor: '#000000',
      },
      textAlign: 'center',
    },

    enabled: false,
  });

  const [settings, setSettings] = useState({
    btnId: id,
    userId: null,
    buttonText: '',

    globalSettings: {
      cornerRadius: 0,
      height: 50,
      width: 150,
      outlineColor: '#000000',
      outlineThickness: 1,
      fillColor: '#fff',
      font: 'Arial',
      fontColor: '#127E10',
      fontSize: 16,
      shadow: {
        angle: 5,
        size: 10,
        distance: 5,
        alpha: 0.5,
        color: '#FF5733', // Bright orange
      },
      highlight: {
        borderColor: '#000000',
        fillColor: '#fff',
        fontColor: '#000000',
      },
      clickSound: '',
      clickSoundFilename: null,
      clickSoundVolume: 1,
      textAlign: 'center',
      marginBottom: 2,
      lineHeight: 1,
      padding: 10,
    },
    customSettings: {
      cornerRadius: 0,
      height: 50,
      width: 150,
      outlineColor: '#000000',
      outlineThickness: 1,
      fillColor: '#fff',
      font: 'Arial',
      fontColor: '#127E10',
      fontSize: 16,
      shadow: {
        angle: 5,
        size: 10,
        distance: 5,
        alpha: 0.5,
        color: '#FF5733', // Bright orange
      },
      highlight: {
        borderColor: '#000000',
        fillColor: '#fff',
        fontColor: '#000000',
      },
      clickSound: '',
      clickSoundFilename: null,
      clickSoundVolume: 1,
      textAlign: 'center',
      marginBottom: 2,
      pngBtnenabled: false,
      hideBtnText: false,
      btnPng: null,
      btnPngFileName: null,
      lineHeight: 1,
      padding: 10,
    }, // Custom overrides
    enabled: false,
  });

  // Function to go back to the previous page
  const goBack = () => {
    navigate(-1); // This will take the user back to the previous page in the browser history
  };

  useEffect(() => {
    const savedLang = localStorage.getItem(`language_pref_${userId}`) || 'en';
    setCurrentLanguage(savedLang);

    fetch(`/api/button-settings/${id}/${userId}/${savedLang}`)
      .then(res => res.json())
      .then(data => {
        if (!data.error) {
          const result = data?.data;
          setSettings(prevSettings => ({
            ...prevSettings,
            globalSettings: {
              ...prevSettings?.globalSettings,
              ...result?.globalSettings, // Merge globalSettings as well
            },
            customSettings: {
              ...prevSettings?.customSettings,
              ...result?.customSettings, // Merge globalSettings as well
            },
            enabled: result?.enabled,
            btnId: id,
            buttonText: result?.buttonText,
          }));

          setButtonColor(data?.site_brand_color);
          setMenuUrl(data?.menu_client_url);

          if (result?.menuLevel === 'primary' || result?.menuLevel === 'frontend') {
            setIsPrimary(true);
          }

          setMenuLevel(result?.menuLevel);

          setParentMenuName(result?.parentMenuName);
          setChildMenuName(result?.chilmenuName);
          setValue(!result?.frontend ? 1 : 0);
          setIsFrontend(result?.frontend);
          SetParentMenuID(result?.parentMenuID);
          setLinkedBtnId(result?.linkbtnId);
          setLinkedTrivia(result?.linkedTrivia);
          setMainMeuLinked(result?.mainMeuLinked);
          setLinkedWayfinder(result?.linkedWayfinder);
        }
      })
      .catch(() => console.log('Button not found, creating new settings.'));
  }, [id]);

  const handleChange = (key, value) => {
    if (!settings.enabled && key !== 'buttonText') {
      Swal.fire({
        icon: 'warning',
        title: 'Are you sure?',
        text: "This page allows you to adjust global button settings. To modify these settings, enable the custom settings button in the top right or click 'Yes, proceed'.",
        showCancelButton: true,
        confirmButtonText: 'Yes, proceed',
        cancelButtonText: 'No, cancel',
        confirmButtonColor: buttonColor,
      }).then(result => {
        if (result.isConfirmed) {
          // Handle confirmation action here
          handleToggleChange(true);
        } else {
          // Handle cancellation action here
          console.log('Action canceled');
        }
      });

      return;
    }

    if (key === 'buttonText') {
      setSettings(prevSettings => {
        return {
          ...prevSettings,
          [key]: value,
        };
      });
    } else {
      // Determine whether to update global or custom settings
      const basePath = settings.enabled ? 'customSettings' : 'globalSettings';
      const fullPath = `${basePath}.${key}`;
      const keys = fullPath.split('.'); // Split the path into parts
      const newSettings = { ...settings };

      keys.reduce((obj, currentKey, index) => {
        if (index === keys.length - 1) {
          // If it's the last key, update the value
          obj[currentKey] = value;
        } else {
          // Otherwise, ensure the object exists before traversing
          obj[currentKey] = { ...obj[currentKey] };
        }
        return obj[currentKey];
      }, newSettings);

      setSettings(newSettings);
    }
  };

  const handleChangePrimaryText = (key, value) => {
    // Determine whether to update global or custom settings
    const basePath = 'globalSettings';
    const fullPath = `${basePath}.${key}`;
    const keys = fullPath.split('.'); // Split the path into parts
    const newSettings = { ...primaryMenuTextsettings };

    keys.reduce((obj, currentKey, index) => {
      if (index === keys.length - 1) {
        // If it's the last key, update the value
        obj[currentKey] = value;
      } else {
        // Otherwise, ensure the object exists before traversing
        obj[currentKey] = { ...obj[currentKey] };
      }
      return obj[currentKey];
    }, newSettings);

    setPrimaryMenuTextSettings(newSettings);
  };

  const handleSubmit = async e => {
    e.preventDefault();

    const settingsToSave = {
      ...settings,
      userId: userId,
      currentLanguage: currentLanguage,
    };

    try {
      const response = await fetch(`/api/button-settings-save`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(settingsToSave),
      });

      if (response.ok) {
        showMsgSuccessToast('Button settings saved successfully!');
      } else {
        const error = await response.json();
        console.error('Failed to save button settings:', error.message);
      }
    } catch (error) {
      console.error('Error saving button settings:', error);
    }
  };

  const handleUpload = async (position, file) => {
    if (!file) return;
    setUploadingStates(prev => ({ ...prev, [position]: true }));

    try {
      // Step 1: Get Pre-signed URL from the Backend
      const response = await axios.get('/generate-signed-url', {
        params: {
          fileName: file.name,
          fileType: file.type,
        },
      });

      const { url } = response.data;

      // Step 2: Upload the File to S3
      await axios.put(url, file, {
        headers: {
          'Content-Type': file.type,
        },
      });

      // Step 3: Save Uploaded File Information
      const fileUrl = url.split('?')[0]; // Remove query params to get the actual file URL

      // Step 4: Update Settings with language-specific btnPng
      let updatedSettings;
      setSettings(prevSettings => {
        const settingsKey = prevSettings.enabled ? 'customSettings' : 'globalSettings';
        updatedSettings = { ...prevSettings };

        if (position === 'btnSound') {
          updatedSettings[settingsKey] = {
            ...updatedSettings[settingsKey],
            clickSound: fileUrl,
            clickSoundFilename: file.name,
          };
        } else if (position === 'btnPng') {
          // Handle language-specific btnPng
          const currentBtnPng = updatedSettings[settingsKey].btnPng || {};
          const currentBtnPngFileName = updatedSettings[settingsKey].btnPngFileName || {};

          // If btnPng is a string (old format), convert to object
          const btnPngObj = typeof currentBtnPng === 'string' ? { en: currentBtnPng } : currentBtnPng;
          const btnPngFileNameObj = typeof currentBtnPngFileName === 'string' ? { en: currentBtnPngFileName } : currentBtnPngFileName;

          updatedSettings[settingsKey] = {
            ...updatedSettings[settingsKey],
            btnPng: {
              ...btnPngObj,
              [currentLanguage]: fileUrl
            },
            btnPngFileName: {
              ...btnPngFileNameObj,
              [currentLanguage]: file.name
            },
          };
        }

        return updatedSettings;
      });

      // Step 5: Save btnPng to backend immediately after upload
      if (position === 'btnPng') {
        try {
          const saveResponse = await fetch(`/api/button-settings-save`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              ...updatedSettings,
              userId: userId,
              currentLanguage: currentLanguage,
            }),
          });

          if (saveResponse.ok) {
            showMsgSuccessToast('PNG uploaded and saved successfully!');
          } else {
            const error = await saveResponse.json();
            console.error('Failed to save PNG to backend:', error.message);
            showErrorToast('PNG uploaded but failed to save settings.');
          }
        } catch (saveError) {
          console.error('Error saving PNG to backend:', saveError);
          showErrorToast('PNG uploaded but failed to save settings.');
        }
      }

      setUploadingStates(prev => ({ ...prev, [position]: false }));

      //showMsgSuccessToast("Button Click Sound Media Uploaded Successfully");
    } catch (error) {
      console.error('Upload failed:', error);

      showErrorToast('File Upload Failed Please try again.');
      setUploadingStates(prev => ({ ...prev, [position]: false }));
    }
  };

  const handleUploadIcon = async () => {
    if (!btnIcon) {
      showErrorToast('Please select an icon file first!');
      return;
    }

    setUploadingStates(prev => ({ ...prev, btnIcon: true }));

    try {
      // Step 1: Get Pre-signed URL from the Backend
      const response = await axios.get('/generate-signed-url', {
        params: {
          fileName: btnIcon.name,
          fileType: btnIcon.type,
        },
      });

      const { url } = response.data;

      // Step 2: Upload the File to S3
      await axios.put(url, btnIcon, {
        headers: {
          'Content-Type': btnIcon.type,
        },
      });

      // Step 3: Save Uploaded File Information
      const fileUrl = url.split('?')[0];

      // Step 4: Update Settings
      let updatedSettings;
      setSettings(prevSettings => {
        const settingsKey = prevSettings.enabled ? 'customSettings' : 'globalSettings';
        updatedSettings = {
          ...prevSettings,
          [settingsKey]: {
            ...prevSettings[settingsKey],
            buttonIcon: fileUrl,
            buttonIconFileName: btnIcon.name,
          },
        };
        return updatedSettings;
      });

      // Step 5: Save to backend immediately after upload
      try {
        const saveResponse = await fetch(`/api/button-settings-save`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            ...updatedSettings,
            userId: userId,
            currentLanguage: currentLanguage,
          }),
        });

        if (saveResponse.ok) {
          showMsgSuccessToast('Icon uploaded and saved successfully!');
        } else {
          const error = await saveResponse.json();
          console.error('Failed to save icon to backend:', error.message);
          showErrorToast('Icon uploaded but failed to save settings.');
        }
      } catch (saveError) {
        console.error('Error saving icon to backend:', saveError);
        showErrorToast('Icon uploaded but failed to save settings.');
      }

      setUploadingStates(prev => ({ ...prev, btnIcon: false }));
    } catch (error) {
      console.error('Icon upload failed:', error);
      showErrorToast('Icon upload failed. Please try again.');
      setUploadingStates(prev => ({ ...prev, btnIcon: false }));
    }
  };

  const handleToggleChange = async isOn => {
    setSettings(prevSettings => ({
      ...prevSettings,
      enabled: isOn, // Update the 'enabled' setting
    }));

    const settingsToSave = {
      ...settings,
      enabled: isOn,
      userId: userId,
      currentLanguage: currentLanguage,
    };

    try {
      const response = await fetch(`/api/button-settings-save`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(settingsToSave),
      });

      if (response.ok) {
      } else {
        const error = await response.json();
        console.error('Failed to save button settings:', error.message);
      }
    } catch (error) {
      console.error('Error saving button settings:', error);
    }
  };

  const handleTogglePngBtnChange = async isOn => {
    const alertText =
      'Since PNG is enabled, only Height, Width, Margin Bottom, Font Family,Font color,Font Size and Background Image settings will be applied.';

    if (isOn) {
      Swal.fire({
        icon: 'info',
        title: 'Important Information',
        text: alertText,
        showCancelButton: false,
        confirmButtonText: 'Close',
        cancelButtonText: 'No, cancel',
        confirmButtonColor: buttonColor,
      }).then(result => {
        if (result.isConfirmed) {
          //handleToggleChange(true);
        } else {
          console.log('Action canceled');
        }
      });
    }

    // Update state correctly
    setSettings(prevSettings => ({
      ...prevSettings,
      customSettings: {
        ...prevSettings.customSettings,
        pngBtnenabled: isOn,
      },
    }));

    // Create updated settings
    const updatedSettings = {
      ...settings,
      customSettings: {
        ...settings.customSettings,
        pngBtnenabled: isOn,
      },
      userId: userId,
      currentLanguage: currentLanguage, // Add current language
    };

    try {
      const response = await fetch(`/api/button-settings-save`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(updatedSettings),
      });

      if (response.ok) {
        console.log('Button settings saved successfully.');
      } else {
        const error = await response.json();
        console.error('Failed to save button settings:', error.message);
      }
    } catch (error) {
      console.error('Error saving button settings:', error);
    }
  };

  const handleToggleHideBtnText = async isOn => {
    // Update state correctly
    setSettings(prevSettings => ({
      ...prevSettings,
      customSettings: {
        ...prevSettings.customSettings,
        hideBtnText: isOn,
      },
    }));

    // Create updated settings
    const updatedSettings = {
      ...settings,
      customSettings: {
        ...settings.customSettings,
        hideBtnText: isOn,
      },
      userId: userId,
      currentLanguage: currentLanguage, // Add current language
    };

    try {
      const response = await fetch(`/api/button-settings-save`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(updatedSettings),
      });

      if (response.ok) {
        console.log('Button settings saved successfully.');
      } else {
        const error = await response.json();
        console.error('Failed to save button settings:', error.message);
      }
    } catch (error) {
      console.error('Error saving button settings:', error);
    }
  };

  const handleToggleIconChange = async isOn => {
    // Update state correctly
    setSettings(prevSettings => ({
      ...prevSettings,
      customSettings: {
        ...prevSettings.customSettings,
        enableIcon: isOn,
      },
    }));

    // Create updated settings
    const updatedSettings = {
      ...settings,
      customSettings: {
        ...settings.customSettings,
        enableIcon: isOn,
      },
      userId: userId,
      currentLanguage: currentLanguage,
    };

    try {
      const response = await fetch(`/api/button-settings-save`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(updatedSettings),
      });

      if (response.ok) {
        console.log('Button settings saved successfully.');
      } else {
        const error = await response.json();
        console.error('Failed to save button settings:', error.message);
      }
    } catch (error) {
      console.error('Error saving button settings:', error);
    }
  };

  // Drop handlers for different media
  const createDropHandler = setMedia => acceptedFiles => {
    if (acceptedFiles.length > 0) {
      setMedia(acceptedFiles[0]);
    }
  };

  // Common upload handler
  const handleUploadContent = async (file, position) => {
    if (!file) {
      showErrorToast(`Please select a file for ${position} first!`);
      return;
    }

    // Set the specific position to uploading
    setUploadingStates(prev => ({ ...prev, [position]: true }));

    try {
      // Step 1: Get Pre-signed URL from the Backend
      const response = await axios.get('/generate-signed-url', {
        params: {
          fileName: file.name,
          fileType: file.type,
        },
      });

      const { url } = response.data;

      // Step 2: Upload the File to S3
      await axios.put(url, file, {
        headers: {
          'Content-Type': file.type,
        },
      });

      // Step 3: Save Uploaded File Information
      const fileUrl = url.split('?')[0];

      setUploadedUrls(prev => ({
        ...prev,
        [position]: {
          ...prev[position],
          fileName: file.name, // Store file name
          fileUrl: fileUrl, // Store file URL
          enabled: true,
        },
      }));
      setUploadingStates(prev => ({ ...prev, [position]: false }));

      setUploadedUrls(prevState => ({
        ...prevState,
        [position]: {
          ...prevState[position],
          enabled: true,
        },
      }));
    } catch (error) {
      console.error('Upload failed:', error);
    }
  };

  const handleToggleChangeMedia = (mediaKey, on) => {
    setUploadedUrls(prevState => ({
      ...prevState,
      [mediaKey]: {
        ...prevState[mediaKey],
        enabled: on,
      },
    }));
  };

  const handleSubmitPage = async e => {
    e.preventDefault();

    try {
      await axios.post('/api/save-btnmenupage-content', {
        id,
        mediaData: uploadedUrls,
        menuBackButton: menuBackButton,
        qrLink: qrText,
        splashText: splashText,
        videotime: videotime,
        globalSettings: primaryMenuTextsettings,
        menuContent: menuContent,
        externalweblink: externalweblink,
        language: currentLanguage || 'en',
      });

      showMsgSuccessToast('Settings Save Successfully!');
    } catch (error) {
      console.error('Failed to save media data:', error);
      showErrorToast('Error saving media data!');
    }
  };

  useEffect(() => {
    if (id) {
      fetchMediaPage(id);
    }
  }, [id]);

  const fetchMediaPage = async (id, lang = currentLanguage) => {
    try {

      // Make an API call to get media data for the user
      const response = await axios.get(`/api/get-btnpage-content/${id}/${lang}`);
      const mediaData = response.data; // Access the first object in the array

      setMenuBackButton(mediaData?.menuBackButton || false);
      if (mediaData?.qrLink) {
        const currentDomain = window.location.origin; // Gets the current domain (e.g., http://example.com)
        const actualQrLink = `${currentDomain}/qr/${encodeURIComponent(mediaData?.qrLink)}`;

        const qr = await QRCode.toDataURL(actualQrLink);
        setQrCode(qr);
        setQrText(mediaData?.qrLink);
      }

      setSplashText(mediaData?.splashText);
      setVideoTime(mediaData?.videotime);
      setExternalweblink(mediaData?.content?.externalweblink);
      setMenuContent(mediaData?.content?.contenttype);

      setPrimaryMenuTextSettings(prevSettings => ({
        ...prevSettings,
        globalSettings: {
          ...prevSettings?.globalSettings,
          ...mediaData?.globalSettings, // Merge globalSettings as well
        },
      }));


      console.log('Fetched media data:', mediaData);

      // Update the state with the retrieved media data
      setUploadedUrls(prevUrls => ({
        ...prevUrls, // Preserve previous data
        leftTop: {
          fileName: mediaData?.content?.leftTop?.fileName || '',
          fileUrl: mediaData?.content?.leftTop?.fileUrl || '',
          enabled: mediaData?.content?.leftTop?.enabled || false,
          width: mediaData?.content?.leftTop?.width || 0,
          height: mediaData?.content?.leftTop?.height || 0,
          disabledPadding: mediaData?.content?.leftTop?.disabledPadding || false,
          disabledMargin: mediaData?.content?.leftTop?.disabledMargin || false,
        },
        leftBottom: {
          fileName: mediaData?.content?.leftBottom?.fileName || '',
          fileUrl: mediaData?.content?.leftBottom?.fileUrl || '',
          enabled: mediaData?.content?.leftBottom?.enabled || false,
          width: mediaData?.content?.leftBottom?.width || 0,
          height: mediaData?.content?.leftBottom?.height || 0,
        },
        rightTop: {
          fileName: mediaData?.content?.rightTop?.fileName || '',
          fileUrl: mediaData?.content?.rightTop?.fileUrl || '',
          enabled: mediaData?.content?.rightTop?.enabled || false,
          width: mediaData?.content?.rightTop?.width || 0,
          height: mediaData?.content?.rightTop?.height || 0,
        },
        rightBottom: {
          fileName: mediaData?.content?.rightBottom?.fileName || '',
          fileUrl: mediaData?.content?.rightBottom?.fileUrl || '',
          enabled: mediaData?.content?.rightBottom?.enabled || false,
          width: mediaData?.content?.rightBottom?.width || 0,
          height: mediaData?.content?.rightBottom?.height || 0,
        },
        splashVideo: {
          fileName: mediaData?.content?.splashVideo?.fileName || '',
          fileUrl: mediaData?.content?.splashVideo?.fileUrl || '',
          enabled: mediaData?.content?.splashVideo?.enabled || false,
          captionFile: mediaData?.content?.splashVideo?.captionFile || '',
        },
        splashVideotwo: {
          fileName: mediaData?.content?.splashVideotwo?.fileName || '',
          fileUrl: mediaData?.content?.splashVideotwo?.fileUrl || '',
          enabled: mediaData?.content?.splashVideotwo?.enabled || false,
          captionFile: mediaData?.content?.splashVideotwo?.captionFile || '',
        },
        splashVideothree: {
          fileName: mediaData?.content?.splashVideothree?.fileName || '',
          fileUrl: mediaData?.content?.splashVideothree?.fileUrl || '',
          enabled: mediaData?.content?.splashVideothree?.enabled || false,
          captionFile: mediaData?.content?.splashVideothree?.captionFile || '',
        },
        centerBelowMenuMedia: {
          fileName: mediaData?.content?.centerBelowMenuMedia?.fileName || '',
          fileUrl: mediaData?.content?.centerBelowMenuMedia?.fileUrl || '',
          enabled: mediaData?.content?.centerBelowMenuMedia?.enabled || false,
          width: mediaData?.content?.centerBelowMenuMedia?.width || 0,
          height: mediaData?.content?.centerBelowMenuMedia?.height || 0,
        },
        backMenuMedia: {
          fileName: mediaData?.content?.backMenuMedia?.fileName || '',
          fileUrl: mediaData?.content?.backMenuMedia?.fileUrl || '',
          enabled: mediaData?.content?.backMenuMedia?.enabled || false,
          width: mediaData?.content?.backMenuMedia?.width || 0,
          height: mediaData?.content?.backMenuMedia?.height || 0,
        },
        centerLogoMedia: {
          fileName: mediaData?.content?.centerLogoMedia?.fileName || '',
          fileUrl: mediaData?.content?.centerLogoMedia?.fileUrl || '',
          enabled: mediaData?.content?.centerLogoMedia?.enabled || false,
          width: mediaData?.content?.centerLogoMedia?.width || 0,
          height: mediaData?.content?.centerLogoMedia?.height || 0,
        },
      }));
    } catch (error) {
      console.error('Failed to fetch media data:', error);
    }
  };

  const generateQRCode = async () => {
    try {
      const currentDomain = window.location.origin; // Gets the current domain (e.g., http://example.com)
      const QrUrl = `${currentDomain}/qr/${encodeURIComponent(qrText)}/${id}`;
      setQrLoad(true);

      if (!corner) {
        showErrorToast('Please Select Position OF QR');
        return false;
      }

      const response = await axios.post('/api/generate-qr-code', {
        fields_data: {
          qr_type: 1,
          url: QrUrl,
          name: settings?.buttonText,
        },
        attributes: {
          eyeBallColor: qrSettings?.eyes?.eyeBallColor,
          eyeBallShape: qrSettings?.eyes?.eyeBallShape,
          eyeFrameColor: qrSettings?.eyes?.eyeFrameColor,
          eyeFrameShape: qrSettings?.eyes?.eyeFrameShape,
          frameColor: qrSettings?.frame?.frameColor,
          frameStyle: qrSettings?.frame?.frameStyle,
          frameText: qrSettings?.frame?.frameText,
          logoImage: qrSettings?.logoImage,
          logoScale: 0.809,
          colorDark: qrSettings?.patterns?.colorDark,
          dataPattern: qrSettings?.patterns?.dataPattern,
          backgroundColor:
            qrSettings?.background?.backgroundColor === 'transparent'
              ? 'rgba(255,255,255,0)'
              : qrSettings?.background?.backgroundColor, // Transparent background
          logoMargin: 2,
          foregroundColor: '#2595ff',
        },
        btnId: id,
        corner: corner,
      });

      const result = response.data;
      setQrLoad(false);

      if (result.error) {
        showErrorToast(result?.msg);
      } else {
        //window.open(result?.url, '_blank');
        await fetchMediaPage(id);

        showMsgSuccessToast('Qr Successfully Generated.');
      }
    } catch (err) {
      console.error(err);
    }
  };

  const patterns = [
    {
      id: 1,
      src: 'https://dashboard.uniqode.com/assets/logo/qr-customize/Frame.svg',
      alt: 'Frames',
      type: 'frame',
      options: [
        {
          value: 'banner-bottom',
          src: 'https://dashboard.uniqode.com/assets/img/frames/banner-bottom.svg',
        },
        {
          value: 'balloon-bottom',
          src: 'https://dashboard.uniqode.com/assets/img/frames/balloon-bottom.svg',
        },
        {
          value: 'box-bottom',
          src: 'https://dashboard.uniqode.com/assets/img/frames/box-bottom.svg',
        },
        {
          value: 'banner-top',
          src: 'https://dashboard.uniqode.com/assets/img/frames/banner-top.svg',
        },
        {
          value: 'box-top',
          src: 'https://dashboard.uniqode.com/assets/img/frames/box-top.svg',
        },

        {
          value: 'balloon-top',
          src: 'https://dashboard.uniqode.com/assets/img/frames/balloon-top.svg',
        },
        {
          value: 'text-only',
          src: 'https://dashboard.uniqode.com/assets/img/frames/text-only.svg',
        },
        {
          value: 'none',
          src: 'none',
        },
      ],
    },
    {
      id: 2,
      src: 'https://dashboard.uniqode.com/assets/logo/qr-customize/Logo.svg',
      alt: 'Logo & Background',
      type: 'logo',
      options: null,
    },
    {
      id: 3,
      src: 'https://dashboard.uniqode.com/assets/logo/qr-customize/Eye.svg',
      alt: 'Eyes',
      type: 'eyes',
      options: [
        {
          value: 'square',
          src: 'https://static.uniqode.com/assets/img/mobstac-awesome-qr/eye-balls/square.svg',
        },
        {
          value: 'rounded',
          src: 'https://static.uniqode.com/assets/img/mobstac-awesome-qr/eye-balls/rounded.svg',
        },
        {
          value: 'circle',
          src: 'https://static.uniqode.com/assets/img/mobstac-awesome-qr/eye-balls/circle.svg',
        },
        {
          value: 'left-diamond',
          src: 'https://static.uniqode.com/assets/img/mobstac-awesome-qr/eye-balls/left-diamond.svg',
        },
        {
          value: 'right-diamond',
          src: 'https://static.uniqode.com/assets/img/mobstac-awesome-qr/eye-balls/right-diamond.svg',
        },
        {
          value: 'left-leaf',
          src: 'https://static.uniqode.com/assets/img/mobstac-awesome-qr/eye-balls/left-leaf.svg',
        },
        {
          value: 'right-leaf',
          src: 'https://static.uniqode.com/assets/img/mobstac-awesome-qr/eye-balls/right-leaf.svg',
        },
      ],

      eyeFrame: [
        {
          value: 'square',
          src: 'https://static.uniqode.com/assets/img/mobstac-awesome-qr/eye-frames/square.svg',
        },
        {
          value: 'rounded',
          src: 'https://static.uniqode.com/assets/img/mobstac-awesome-qr/eye-frames/rounded.svg',
        },
        {
          value: 'circle',
          src: 'https://static.uniqode.com/assets/img/mobstac-awesome-qr/eye-frames/circle.svg',
        },
        {
          value: 'left-leaf',
          src: 'https://static.uniqode.com/assets/img/mobstac-awesome-qr/eye-frames/left-leaf.svg',
        },
        {
          value: 'right-leaf',
          src: 'https://static.uniqode.com/assets/img/mobstac-awesome-qr/eye-frames/right-leaf.svg',
        },
      ],
    },
    {
      id: 4,
      src: 'https://dashboard.uniqode.com/assets/logo/qr-customize/Pattern.svg',
      alt: 'Patterns',
      type: 'pattern',
      options: [
        {
          valuee: 'square',
          src: 'https://static.uniqode.com/assets/img/mobstac-awesome-qr/data-patterns/square.svg',
        },
        {
          value: 'circle',
          src: 'https://static.uniqode.com/assets/img/mobstac-awesome-qr/data-patterns/circle.svg',
        },
        {
          value: 'kite',
          src: 'https://static.uniqode.com/assets/img/mobstac-awesome-qr/data-patterns/kite.svg',
        },
        {
          value: 'left-diamond',
          src: 'https://static.uniqode.com/assets/img/mobstac-awesome-qr/data-patterns/left-diamond.svg',
        },
        {
          value: 'right-diamond',
          src: 'https://static.uniqode.com/assets/img/mobstac-awesome-qr/data-patterns/right-diamond.svg',
        },
        {
          value: 'thin-square',
          src: 'https://static.uniqode.com/assets/img/mobstac-awesome-qr/data-patterns/thin-square.svg',
        },
        {
          value: 'smooth-round',
          src: 'https://static.uniqode.com/assets/img/mobstac-awesome-qr/data-patterns/smooth-round.svg',
        },
        {
          value: 'smooth-sharp',
          src: 'https://static.uniqode.com/assets/img/mobstac-awesome-qr/data-patterns/smooth-sharp.svg',
        },
      ],
    },
  ];

  const [selectedPattern, setSelectedPattern] = useState(1);
  const [selectedOption, setSelectedOption] = useState([]); // To store selected options for each pattern
  const [qrUploadingStates, setQrUploadingStates] = useState({
    logoImage: false,
    logoBackground: false,
  });

  const [qrLoad, setQrLoad] = useState(false);

  // Language management
  const [availableLanguages, setAvailableLanguages] = useState([]);
  const [currentLanguage, setCurrentLanguage] = useState('en');
  const [loadingLanguages, setLoadingLanguages] = useState(false);


  // Language helper functions
  const getLanguageFlag = (languageCode) => {
    const flagMap = {
      'en': 'us',
      'es': 'es',
      'fr': 'fr',
      'de': 'de',
      'it': 'it',
      'pt': 'pt',
      'ru': 'ru',
      'ja': 'jp',
      'ko': 'kr',
      'zh': 'cn',
      'ar': 'sa',
      'hi': 'in',
    };
    return flagMap[languageCode] || 'us';
  };

  // const getLanguageName = (languageCode) => {
  //   const nameMap = {
  //     'en': 'English',
  //     'es': 'Spanish',
  //     'fr': 'French',
  //     'de': 'German',
  //     'it': 'Italian',
  //     'pt': 'Portuguese',
  //     'ru': 'Russian',
  //     'ja': 'Japanese',
  //     'ko': 'Korean',
  //     'zh': 'Chinese',
  //     'ar': 'Arabic',
  //     'hi': 'Hindi',
  //   };
  //   return nameMap[languageCode] || languageCode.toUpperCase();
  // };

  const handleLanguageChange = async (newLanguage) => {
    try {
      // Update current language state
      setCurrentLanguage(newLanguage);

      // Save preference to localStorage
      localStorage.setItem(`language_pref_${userId}`, newLanguage);

      // Reload button settings data for the new language
      const response = await fetch(`/api/button-settings/${id}/${userId}/${newLanguage}`);
      const data = await response.json();

      if (!data.error) {
        const result = data?.data;
        setSettings(prevSettings => ({
          ...prevSettings,
          globalSettings: {
            ...prevSettings?.globalSettings,
            ...result?.globalSettings,
          },
          customSettings: {
            ...prevSettings?.customSettings,
            ...result?.customSettings,
          },
          enabled: result?.enabled,
          btnId: id,
          buttonText: result?.buttonText,
        }));
      }

      // Reload media page content for the new language
      if (id) {
        await fetchMediaPage(id, newLanguage);
      }

      // Show success message
      showMsgSuccessToast(`Language changed to ${getLanguageName(newLanguage)}`);
    } catch (error) {
      console.error('Error changing language:', error);
      showErrorToast('Error changing language');
    }
  };

  // Helper function to get language name
  const getLanguageName = (code) => {
    const languageNames = {
      'en': 'English',
      'es': 'Spanish',
      'fr': 'French',
      'de': 'German',
      'it': 'Italian',
      'pt': 'Portuguese',
      'ru': 'Russian',
      'ja': 'Japanese',
      'ko': 'Korean',
      'zh': 'Chinese',
      'ar': 'Arabic',
      'hi': 'Hindi',
    };
    return languageNames[code] || code.toUpperCase();
  };

  // Fetch available languages
  useEffect(() => {
    const fetchAvailableLanguages = async () => {
      try {
        setLoadingLanguages(true);
        const response = await axios.get(`/api/language/${userId}`);
        if (response.data.success) {
          setAvailableLanguages(response.data.languages || ["en"]);

          // Try to get saved language preference from localStorage
          const savedLang = localStorage.getItem(`language_pref_${userId}`);
          if (savedLang && response.data.languages.includes(savedLang)) {
            setCurrentLanguage(savedLang);
          } else {
            // Default to first language or 'en'
            setCurrentLanguage(response.data.languages[0] || "en");
          }
        }
      } catch (error) {
        console.error("Error fetching languages:", error);
        setAvailableLanguages(["en"]);
        setCurrentLanguage("en");
      } finally {
        setLoadingLanguages(false);
      }
    };

    if (userId) {
      fetchAvailableLanguages();
    }
  }, [userId]);

  const handleSelectPattern = id => {
    setSelectedPattern(id);

    const filteroption = patterns.find(e => e.id === id);
    console.log('filteroption', filteroption);

    setSelectedOption(filteroption);
  };

  useEffect(() => {
    handleSelectPattern(selectedPattern);
  }, []);

  const [qrSettings, setQrSettings] = useState({
    frame: {
      frameStyle: 'none',
      frameColor: '#000000',
      frameText: 'SCAN ME',
    },
    eyes: {
      eyeFrameShape: 'square',
      eyeFrameColor: '#000000',
      eyeBallShape: 'square',
      eyeBallColor: '#000000',
    },
    patterns: {
      dataPattern: 'square',
      colorDark: '#000000',
    },
    background: {
      backgroundColor: 'rgba(255,255,255,0)',
    },
    logoImage: null,
  });

  const handleChangeQR = (section, key, value) => {
    setQrSettings(prevSettings => ({
      ...prevSettings,
      [section]: {
        ...prevSettings[section],
        [key]: value,
      },
    }));
  };

  // Common upload handler
  const handleUploadContentQrLog = async file => {
    if (!file) {
      showErrorToast(`Please select a file for  first!`);
      return;
    }

    setQrUploadingStates(prevSettings => ({
      ...prevSettings,
      logoImage: true, // Update the logo image URL
    }));

    try {
      // Step 1: Get Pre-signed URL from the Backend
      const response = await axios.get('/generate-signed-url', {
        params: {
          fileName: file.name,
          fileType: file.type,
        },
      });

      const { url } = response.data;

      // Step 2: Upload the File to S3
      await axios.put(url, file, {
        headers: {
          'Content-Type': file.type,
        },
      });

      // Step 3: Save Uploaded File Information
      const fileUrl = url.split('?')[0];

      setQrSettings(prevSettings => ({
        ...prevSettings,
        logoImage: fileUrl, // Update the logo image URL
      }));

      setQrUploadingStates(prevSettings => ({
        ...prevSettings,
        logoImage: false, // Update the logo image URL
      }));
    } catch (error) {
      console.error('Upload failed:', error);
    }
  };

  const handleChangeCorner = event => {
    setCorner(event.target.value);
  };

  const escapeHtml = unsafe => {
    return unsafe
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  };

  const deleteFile = async (fileNameurl, key) => {
    const decodedUrl = decodeURIComponent(fileNameurl); // Decodes %20 to spaces
    const fileName = decodedUrl.split('/').pop(); // Takes last segment after /
    // Show confirmation dialog

    const result = await Swal.fire({
      title: 'Are you sure?',
      html: `You are about to delete <b>${escapeHtml(fileName)}</b>. <br> This action cannot be undo!`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: buttonColor,
      confirmButtonText: '<i class="fa fa-thumbs-up"></i> Yes, delete it!',
      cancelButtonText: '<i class="fa fa-thumbs-down"></i> Cancel',
    });

    // If user confirms deletion
    if (result.isConfirmed) {
      Swal.fire({
        title: 'Deleting...',
        text: 'Please wait while we delete the file.',
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading(); // Show loading spinner
        },
      });
      try {
        // Call your backend API to delete the file
        const response = await axios.post('/api/menu-page-content', {
          fileName: fileName,
          btnId: id,
          position: key,
        });

        if (response.data.success) {
          // Update the state to remove the file
          setUploadedUrls(prev => ({
            ...prev,
            [key]: {
              fileName: '',
              fileUrl: '',
              enabled: false,
            },
          }));

          // Show success message
          Swal.fire('Deleted!', 'Your file has been deleted.', 'success');
        } else {
          Swal.fire('Error!', 'Failed to delete file.', 'error');
        }
      } catch (error) {
        console.error('Error deleting file:', error);
        Swal.fire('Error!', 'An error occurred while deleting the file.', 'error');
      }
    }
  };

  return (
    <div className="main-container">
      <div className="pd-ltr-20 xs-pd-20-10">
        {' '}
        <div className="min-height-200px dashboard-container">
          <div className="page-header">
            <div className="row">
              <div className="col-md-6 col-sm-12">
                <div className="title">
                  <Typography variant="h4">
                    Main Menu
                    {menuUrl && (
                      <>
                        <Typography component="span" sx={{ fontWeight: 'bold', mx: 1 }}>
                          &gt;&gt;
                        </Typography>
                        {menuUrl.charAt(0).toUpperCase() + menuUrl.slice(1)}
                      </>
                    )}
                    {isPrimary ? (
                      <>
                        <Typography
                          component="span"
                          sx={{ fontWeight: 'bold', color: 'blue', mx: 1 }}
                        >
                          &gt;&gt; {settings?.buttonText.replace(/<br\s*\/?>/gi, ' ')}
                        </Typography>
                      </>
                    ) : (
                      <>
                        <Typography component="span" sx={{ fontWeight: 'bold', mx: 1 }}>
                          &gt;&gt; {parentMenuName.replace(/<br\s*\/?>/gi, ' ')}
                        </Typography>
                        <Typography
                          component="span"
                          sx={{ fontWeight: 'bold', color: 'blue', mx: 1 }}
                        >
                          &gt;&gt; {chilmenuName.replace(/<br\s*\/?>/gi, ' ')}
                        </Typography>
                      </>
                    )}
                  </Typography>
                </div>
              </div>

              <div className="col-md-3 col-sm-12 d-flex align-items-center justify-content-end">
                {loadingLanguages ? (
                  <div className="d-flex align-items-center">
                    <div className="spinner-border spinner-border-sm me-2" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                    <span>Loading languages...</span>
                  </div>
                ) : availableLanguages.length > 1 ? (
                  <div className="language-switcher">
                    <div className="dropdown">
                      <button
                        className="btn btn-outline-secondary dropdown-toggle d-flex align-items-center"
                        type="button"
                        id="languageDropdown"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                        style={{
                          borderColor: buttonColor,
                          color: buttonColor,
                          backgroundColor: "transparent",
                        }}
                      >
                        <span
                          className={`fi fi-${getLanguageFlag(currentLanguage)} me-2`}
                          style={{ fontSize: "16px" }}
                        ></span>
                        <span className="me-1">{getLanguageName(currentLanguage)}</span>
                        <span
                          className="badge bg-primary ms-1"
                          style={{ backgroundColor: buttonColor }}
                        >
                          {availableLanguages.length}
                        </span>
                      </button>
                      <ul className="dropdown-menu" aria-labelledby="languageDropdown">
                        {availableLanguages.map((lang) => (
                          <li key={lang}>
                            <button
                              className={`dropdown-item d-flex align-items-center ${currentLanguage === lang ? "active" : ""
                                }`}
                              onClick={() => handleLanguageChange(lang)}
                              style={{
                                backgroundColor:
                                  currentLanguage === lang ? `${buttonColor}20` : "transparent",
                              }}
                            >
                              <span
                                className={`fi fi-${getLanguageFlag(lang)} me-2`}
                                style={{ fontSize: "16px" }}
                              ></span>
                              <span>{getLanguageName(lang)}</span>
                              {currentLanguage === lang && (
                                <i className="fas fa-check ms-auto text-success"></i>
                              )}
                            </button>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                ) : (
                  <div className="d-flex align-items-center text-muted">
                    <span
                      className={`fi fi-${getLanguageFlag(currentLanguage)} me-2`}
                      style={{ fontSize: "16px" }}
                    ></span>
                    <span>{getLanguageName(currentLanguage)}</span>
                    <small className="ms-2">(Only language available)</small>
                  </div>
                )}
              </div>

              <div className="col-md-3 col-sm-12">
                <button
                  type="button"
                  onClick={goBack}
                  style={{ float: 'right', backgroundColor: buttonColor }}
                  className="btn btn-success"
                >
                  {`<< Back To Main Menu`}
                </button>
              </div>
            </div>
          </div>

          <Box sx={{ width: '100%' }}>
            <Tabs
              value={value}
              onChange={handleTabChange}
              aria-label="tab navigation"
              sx={{
                '& .MuiTab-root': { minWidth: 100 }, // Ensures consistent width
                '& .Mui-selected': { fontWeight: 'bold' }, // Active tab styling
              }}
            >
              <Tab
                sx={{
                  '&:hover': {
                    backgroundColor: buttonColor, // Add your desired hover color here
                    color: '#fff',
                    fontWeight: 'bold',
                  },
                }}
                style={{ display: isFrontend || menuLevel === 'secondary' ? 'block' : 'none' }}
                label="Button Settings"
              />
              <Tab
                sx={{
                  '&:hover': {
                    backgroundColor: buttonColor, // Add your desired hover color here
                    color: '#fff',
                    fontWeight: 'bold',
                  },
                }}
                //style={{display: isFrontend ? 'none' : 'block'}}

                label="Page Content"
              />

              <Tab
                sx={{
                  '&:hover': {
                    backgroundColor: buttonColor, // Add your desired hover color here
                    color: '#fff',
                    fontWeight: 'bold',
                  },
                }}
                //style={{display: isFrontend ? 'none' : 'block'}}

                label="Generate Qr Code"
              />

              <Tab
                sx={{
                  '&:hover': {
                    backgroundColor: buttonColor, // Add your desired hover color here
                    color: '#fff',
                    fontWeight: 'bold',
                  },
                }}
                style={{ display: 'none' }}
                label="Button Text Settings"
              />

              <Tab
                sx={{
                  '&:hover': {
                    backgroundColor: buttonColor, // Add your desired hover color here
                    color: '#fff',
                    fontWeight: 'bold',
                  },
                }}
                style={{ display: menuLevel === 'primary' ? 'none' : 'block' }}
                label="Navigation"
              />
            </Tabs>

            <Box sx={{ p: 3 }}>
              {value === 0 && (
                <>
                  <ToggleSwitch
                    label="Enable Custom Settings"
                    isOn={settings.enabled}
                    onChange={handleToggleChange}
                  />

                  <form
                    className="tab-wizard wizard-circle wizard vertical"
                    onSubmit={handleSubmit}
                  >
                    {settings?.enabled && (
                      <div
                        style={{
                          marginLeft: '-28px',
                          display: 'flex',
                          alignItems: 'center',
                          gap: '10px',
                          marginTop: '20px',
                        }}
                      >
                        <ToggleSwitch
                          label="Enable PNG Button Settings"
                          isOn={settings?.customSettings?.pngBtnenabled}
                          onChange={handleTogglePngBtnChange}
                          id="pngbtn"
                        />
                        <ToggleSwitch
                          label="Hide Button Text?"
                          isOn={settings?.customSettings?.hideBtnText}
                          onChange={handleToggleHideBtnText}
                          id="hideBtntext"
                        />
                        <ToggleSwitch
                          label="Enable Icon"
                          isOn={settings?.customSettings?.enableIcon}
                          onChange={handleToggleIconChange}
                          id="enableIcon"
                        />
                      </div>
                    )}

                    {/* Global Settings */}
                    {/* <h4>{settings?.enabled ? 'Custom' : 'Global'} Settings</h4> */}
                    <div
                      style={{ marginTop: '20px' }}
                      className="col d-flex justify-content-between"
                    >
                      <div
                        className="left form-group"
                        style={{
                          marginLeft: '-28px',
                          display: 'flex',
                          flexDirection: 'column', // stack items vertically
                          alignItems: 'flex-start',
                          gap: '10px',
                        }}
                      >
                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                          <input
                            type="text"
                            value={settings?.buttonText}
                            onChange={e => handleChange('buttonText', e.target.value)}
                            className="form-control"
                          />
                          <button
                            style={{ backgroundColor: buttonColor }}
                            type="button"
                            onClick={handleSubmit}
                          >
                            Update
                          </button>
                        </div>

                        {/* Note line added here */}
                        <small style={{ color: '#000000' }}>
                          You can use the <code>&lt;br&gt;</code> tag in the input to break text
                          into a new line on the button.
                        </small>
                      </div>

                      <div className="right" style={{ marginTop: '20px', marginRight: '-29px' }}>
                        <Button
                          key={settings.btnId}
                          text={settings?.buttonText || 'Sample Button'}
                          settings={
                            settings.enabled ? settings?.customSettings : settings?.globalSettings
                          }
                        />
                      </div>
                    </div>

                    <div className="row menu-card2">
                      <div className="col-md-4">
                        <div className="form-group">
                          <label>Font Line Height:</label>
                          <input
                            type="number"
                            className="form-control"
                            value={
                              settings.enabled
                                ? (settings?.customSettings?.lineHeight ?? 1)
                                : (settings?.customSettings?.lineHeight ?? 1)
                            }
                            disabled={settings?.customSettings?.pngBtnenabled}
                            onChange={e => handleChange('lineHeight', Number(e.target.value))}
                          />
                        </div>
                      </div>

                      <div className="col-md-4">
                        <div className="form-group">
                          <label>Padding:</label>
                          <input
                            type="number"
                            className="form-control"
                            value={
                              settings.enabled
                                ? (settings?.customSettings?.padding ?? 10)
                                : (settings?.customSettings?.padding ?? 10)
                            }
                            disabled={settings?.customSettings?.pngBtnenabled}
                            onChange={e => handleChange('padding', Number(e.target.value))}
                          />
                        </div>
                      </div>

                      <div className="col-md-4">
                        <div className="form-group">
                          <label>Margin Bottom:</label>
                          <input
                            type="number"
                            className="form-control"
                            value={
                              settings.enabled
                                ? (settings?.customSettings?.marginBottom ?? 0)
                                : (settings?.customSettings?.marginBottom ?? 0)
                            }
                            onChange={e => handleChange('marginBottom', Number(e.target.value))}
                          />
                        </div>
                      </div>
                    </div>

                    <div className="row menu-card2">
                      <div className="col-md-4">
                        <div className="form-group">
                          <label>Corner Radius:</label>
                          <input
                            type="number"
                            className="form-control"
                            value={
                              settings.enabled
                                ? (settings?.customSettings?.cornerRadius ?? 0)
                                : (settings?.customSettings?.cornerRadius ?? 0)
                            }
                            disabled={settings?.customSettings?.pngBtnenabled}
                            onChange={e => handleChange('cornerRadius', Number(e.target.value))}
                          />
                        </div>
                      </div>

                      <div className="col-md-4">
                        <div className="form-group">
                          <label>Height:</label>
                          <input
                            type="number"
                            value={
                              settings.enabled
                                ? (settings?.customSettings?.height ?? 0)
                                : (settings?.customSettings?.height ?? 0)
                            }
                            onChange={e => handleChange('height', Number(e.target.value))}
                            className="form-control"
                          />
                        </div>
                      </div>

                      <div className="col-md-4">
                        <div className="form-group">
                          <label>Width:</label>
                          <input
                            type="number"
                            value={
                              settings.enabled
                                ? (settings?.customSettings?.width ?? 0)
                                : (settings?.customSettings?.width ?? 0)
                            }
                            onChange={e => handleChange('width', Number(e.target.value))}
                            className="form-control"
                          />
                        </div>
                      </div>
                    </div>

                    {/* Outline */}

                    <div className="row menu-card2">
                      <div className="col-md-4">
                        <div className="form-group">
                          <label className="d-flex align-items-center" style={{ height: '21px' }}>
                            Outline color: (Transparent
                            <input
                              type="checkbox"
                              className="ml-1 mr-1"
                              checked={settings?.customSettings?.outlineColor === 'transparent'}
                              disabled={settings?.customSettings?.pngBtnenabled}
                              onChange={e =>
                                handleChange(
                                  'outlineColor',
                                  e.target.checked ? 'transparent' : '#000000'
                                )
                              }
                            />
                            )
                          </label>
                          <MuiColorInput
                            className="form-control mt-1"
                            format="hex"
                            value={
                              settings.customSettings.outlineColor === 'transparent'
                                ? ''
                                : settings.customSettings.outlineColor
                            }
                            onChange={newHex =>
                              handleChange('outlineColor', newHex?.toUpperCase?.() || '#000000')
                            }
                            fallbackValue="#000000"
                            disabled={
                              settings?.customSettings?.outlineColor === 'transparent' ||
                              settings?.customSettings?.pngBtnenabled
                            }
                            // size="small"
                            isAlphaHidden={true} // This disables the alpha slider
                            sx={{
                              '& .MuiOutlinedInput-root': {
                                borderRadius: '0px !important',
                                height: 53,
                              },
                              '& .MuiOutlinedInput-input': {
                                height: '36px',
                              },
                              '& .MuiColorInput-Button': {
                                width: '49px !important', // Increase width
                                height: '40px !important',
                              },
                              '& .MuiInputAdornment-root .MuiBox-root': {
                                width: 18,
                                height: 18,
                              },
                            }}
                          />

                          {/* <input
                            type="color"
                            className="form-control mt-1"
                            disabled={settings?.customSettings?.outlineColor === "transparent" || settings?.customSettings?.pngBtnenabled} // Disable when transparent
                            value={
                              settings.enabled
                                ? settings?.customSettings?.outlineColor || "#000000"
                                : settings?.customSettings?.outlineColor || "#000000"
                            }

                            onChange={(e) => handleChange("outlineColor", e.target.value)}
                          /> */}
                        </div>
                      </div>

                      <div className="col-md-4">
                        <div className="form-group">
                          <label>Outline Thickness:</label>
                          <input
                            type="number"
                            value={
                              settings.enabled
                                ? (settings?.customSettings?.outlineThickness ?? 0)
                                : (settings?.customSettings?.outlineThickness ?? 0)
                            }
                            disabled={settings?.customSettings?.pngBtnenabled}
                            onChange={e => handleChange('outlineThickness', Number(e.target.value))}
                            className="form-control"
                          />
                        </div>
                      </div>

                      <div className="col-md-4">
                        <div className="form-group">
                          <label>Text Alignment (left centre or right):</label>

                          <select
                            id="textAlign"
                            value={
                              settings.enabled
                                ? settings?.customSettings?.textAlign || 'left'
                                : settings?.customSettings?.textAlign || 'left'
                            }
                            disabled={settings?.customSettings?.pngBtnenabled}
                            onChange={e => handleChange('textAlign', e.target.value)}
                            className="form-select form-control"
                          >
                            <option value="left">Left</option>
                            <option value="center">Center</option>
                            <option value="right">Right</option>
                          </select>
                        </div>
                      </div>
                    </div>

                    {/* Fill Color */}
                    <div className="row menu-card2">
                      <div className="col-md-3">
                        <div className="form-group">
                          <label className="d-flex align-items-center" style={{ height: '21px' }}>
                            Fill color: (Transparent
                            <input
                              type="checkbox"
                              className="ml-1 mr-1"
                              checked={
                                settings?.customSettings?.fillColor === 'transparent' ||
                                settings?.customSettings?.pngBtnenabled
                              }
                              disabled={settings?.customSettings?.pngBtnenabled}
                              onChange={e =>
                                handleChange(
                                  'fillColor',
                                  e.target.checked ? 'transparent' : '#000000'
                                )
                              }
                            />
                            )
                          </label>

                          <MuiColorInput
                            className="form-control mt-1"
                            format="hex"
                            value={
                              settings.customSettings.fillColor === 'transparent'
                                ? ''
                                : settings.customSettings.fillColor
                            }
                            onChange={newHex =>
                              handleChange('fillColor', newHex?.toUpperCase?.() || '#000000')
                            }
                            fallbackValue="#000000"
                            disabled={
                              settings?.customSettings?.fillColor === 'transparent' ||
                              settings?.customSettings?.pngBtnenabled
                            }
                            // size="small"
                            isAlphaHidden={true} // This disables the alpha slider
                            sx={{
                              '& .MuiOutlinedInput-root': {
                                borderRadius: '0px !important',
                                height: 53,
                              },
                              '& .MuiOutlinedInput-input': {
                                height: '36px',
                              },
                              '& .MuiColorInput-Button': {
                                width: '49px !important', // Increase width
                                height: '40px !important',
                              },
                              '& .MuiInputAdornment-root .MuiBox-root': {
                                width: 18,
                                height: 18,
                              },
                            }}
                          />

                          {/* <input
                            type="color"
                            className="form-control"
                            disabled={settings?.customSettings?.fillColor === "transparent" || settings?.customSettings?.pngBtnenabled} // Disable when transparent

                            value={
                              settings.enabled ?
                                settings?.customSettings?.fillColor || "#000000" :
                                settings?.customSettings?.fillColor || "#000000"
                            }
                            onChange={(e) => handleChange('fillColor', e.target.value)}
                          /> */}
                        </div>
                      </div>

                      <div className="col-md-3">
                        <div className="form-group">
                          <label>Font Family:</label>

                          <select
                            id="font"
                            value={
                              settings.enabled
                                ? settings?.customSettings?.font || 'Arial'
                                : settings?.customSettings?.font || 'Arial'
                            }
                            onChange={e => handleChange('font', e.target.value)}
                            className="form-select form-control"
                          >
                            {fontOptions}
                          </select>
                        </div>
                      </div>

                      <div className="col-md-3">
                        <div className="form-group">
                          <label className="d-flex align-items-center" style={{ height: '21px' }}>
                            Font color: (Transparent
                            <input
                              type="checkbox"
                              className="ml-1 mr-1"
                              checked={settings?.customSettings?.fontColor === 'transparent'}
                              onChange={e =>
                                handleChange(
                                  'fontColor',
                                  e.target.checked ? 'transparent' : '#00000'
                                )
                              }
                            />
                            )
                          </label>

                          <MuiColorInput
                            className="form-control mt-1"
                            format="hex"
                            value={
                              settings.customSettings.fontColor === 'transparent'
                                ? ''
                                : settings.customSettings.fontColor
                            }
                            onChange={newHex =>
                              handleChange('fontColor', newHex?.toUpperCase?.() || '#000000')
                            }
                            fallbackValue="#000000"
                            disabled={settings?.customSettings?.fontColor === 'transparent'}
                            // size="small"
                            isAlphaHidden={true} // This disables the alpha slider
                            sx={{
                              '& .MuiOutlinedInput-root': {
                                borderRadius: '0px !important',
                                height: 53,
                              },
                              '& .MuiOutlinedInput-input': {
                                height: '36px',
                              },
                              '& .MuiColorInput-Button': {
                                width: '49px !important', // Increase width
                                height: '40px !important',
                              },
                              '& .MuiInputAdornment-root .MuiBox-root': {
                                width: 18,
                                height: 18,
                              },
                            }}
                          />

                          {/* <input
                            type="color"
                            disabled={settings?.customSettings?.fontColor === "transparent"} // Disable when transparent

                            value={
                              settings.enabled ?
                                settings?.customSettings?.fontColor || "#000000" :
                                settings?.customSettings?.fontColor || "#000000"
                            }
                            onChange={(e) => handleChange('fontColor', e.target.value)}
                            className="form-control"
                          /> */}
                        </div>
                      </div>

                      <div className="col-md-3">
                        <div className="form-group">
                          <label>Font Size:</label>
                          <input
                            type="number"
                            value={
                              settings.enabled
                                ? settings?.customSettings?.fontSize || ''
                                : settings?.customSettings?.fontSize || ''
                            }
                            onChange={e => handleChange('fontSize', Number(e.target.value))}
                            className="form-control"
                          />
                        </div>
                      </div>
                    </div>

                    {/* Shadow Settings */}

                    <div className="row menu-card2">
                      <div className="col-md-2">
                        <div className="form-group">
                          <label>Shadow angle:</label>
                          <input
                            type="number"
                            className="form-control"
                            value={
                              settings.enabled
                                ? (settings?.customSettings?.shadow?.angle ?? 0)
                                : (settings?.customSettings?.shadow?.angle ?? 0)
                            }
                            disabled={settings?.customSettings?.pngBtnenabled}
                            onChange={e => handleChange('shadow.angle', Number(e.target.value))}
                          />
                        </div>
                      </div>

                      <div className="col-md-2">
                        <div className="form-group">
                          <label>Shadow size:</label>
                          <input
                            type="number"
                            value={
                              settings.enabled
                                ? (settings?.customSettings?.shadow?.size ?? 0)
                                : (settings?.customSettings?.shadow?.size ?? 0)
                            }
                            disabled={settings?.customSettings?.pngBtnenabled}
                            onChange={e => handleChange('shadow.size', Number(e.target.value))}
                            className="form-control"
                          />
                        </div>
                      </div>

                      <div className="col-md-2">
                        <div className="form-group">
                          <label>Shadow distance:</label>
                          <input
                            type="number"
                            value={
                              settings.enabled
                                ? (settings?.customSettings?.shadow?.distance ?? 0)
                                : (settings?.customSettings?.shadow?.distance ?? 0)
                            }
                            disabled={settings?.customSettings?.pngBtnenabled}
                            onChange={e => handleChange('shadow.distance', Number(e.target.value))}
                            className="form-control"
                          />
                        </div>
                      </div>

                      <div className="col-md-2">
                        <div className="form-group">
                          <label>Shadow Alpha:</label>
                          <input
                            type="number"
                            value={
                              settings.enabled
                                ? (settings?.customSettings?.shadow?.alpha ?? 0)
                                : (settings?.customSettings?.shadow?.alpha ?? 0)
                            }
                            disabled={settings?.customSettings?.pngBtnenabled}
                            onChange={e => handleChange('shadow.alpha', Number(e.target.value))}
                            className="form-control"
                          />
                        </div>
                      </div>

                      <div className="col-md-4">
                        <div className="form-group">
                          <label className="d-flex align-items-center" style={{ height: '25px' }}>
                            Shadow color: (Transparent
                            <input
                              type="checkbox"
                              className="ml-1 mr-1"
                              checked={settings?.customSettings?.shadow?.color === 'transparent'}
                              disabled={settings?.customSettings?.pngBtnenabled}
                              onChange={e =>
                                handleChange(
                                  'shadow.color',
                                  e.target.checked ? 'transparent' : '#00000'
                                )
                              }
                            />
                            )
                          </label>

                          <MuiColorInput
                            className="form-control mt-1"
                            format="hex"
                            value={
                              settings?.customSettings?.shadow?.color === 'transparent'
                                ? ''
                                : settings?.customSettings?.shadow?.color
                            }
                            onChange={newHex =>
                              handleChange('shadow.color', newHex?.toUpperCase?.() || '#000000')
                            }
                            fallbackValue="#000000"
                            disabled={
                              settings?.customSettings?.shadow?.color === 'transparent' ||
                              settings?.customSettings?.pngBtnenabled
                            }
                            // size="small"
                            isAlphaHidden={true} // This disables the alpha slider
                            sx={{
                              '& .MuiOutlinedInput-root': {
                                borderRadius: '0px !important',
                                height: 53,
                              },
                              '& .MuiOutlinedInput-input': {
                                height: '36px',
                              },
                              '& .MuiColorInput-Button': {
                                width: '49px !important', // Increase width
                                height: '40px !important',
                              },
                              '& .MuiInputAdornment-root .MuiBox-root': {
                                width: 18,
                                height: 18,
                              },
                            }}
                          />

                          {/* <input
                            type="color"
                            disabled={settings?.customSettings?.shadow?.color === "transparent" || settings?.customSettings?.pngBtnenabled} // Disable when transparent

                            value={
                              settings.enabled ?
                                settings?.customSettings?.shadow?.color || "#000000" :
                                settings?.customSettings?.shadow?.color || "#000000"
                            }
                            onChange={(e) => handleChange('shadow.color', e.target.value)}
                            className="form-control"
                          /> */}
                        </div>
                      </div>
                    </div>

                    {/* Highlight */}

                    <div className="row menu-card2">
                      <div className="col-md-4">
                        <div className="form-group">
                          <label className="d-flex align-items-center" style={{ height: '21px' }}>
                            Highlight boarder color: (Transparent
                            <input
                              type="checkbox"
                              className="ml-1 mr-1"
                              disabled={settings?.customSettings?.pngBtnenabled}
                              checked={
                                settings?.customSettings?.highlight?.borderColor === 'transparent'
                              }
                              onChange={e =>
                                handleChange(
                                  'highlight.borderColor',
                                  e.target.checked ? 'transparent' : '#00000'
                                )
                              }
                            />
                            )
                          </label>

                          <MuiColorInput
                            className="form-control mt-1"
                            format="hex"
                            value={
                              settings?.customSettings?.highlight?.borderColor === 'transparent'
                                ? ''
                                : settings?.customSettings?.highlight?.borderColor
                            }
                            onChange={newHex =>
                              handleChange(
                                'highlight.borderColor',
                                newHex?.toUpperCase?.() || '#000000'
                              )
                            }
                            fallbackValue="#000000"
                            disabled={
                              settings?.customSettings?.highlight?.borderColor === 'transparent' ||
                              settings?.customSettings?.pngBtnenabled
                            }
                            // size="small"
                            isAlphaHidden={true} // This disables the alpha slider
                            sx={{
                              '& .MuiOutlinedInput-root': {
                                borderRadius: '0px !important',
                                height: 53,
                              },
                              '& .MuiOutlinedInput-input': {
                                height: '36px',
                              },
                              '& .MuiColorInput-Button': {
                                width: '49px !important', // Increase width
                                height: '40px !important',
                              },
                              '& .MuiInputAdornment-root .MuiBox-root': {
                                width: 18,
                                height: 18,
                              },
                            }}
                          />

                          {/* <input
                            type="color"
                            className="form-control"
                            disabled={settings?.customSettings?.highlight?.borderColor === "transparent" || settings?.customSettings?.pngBtnenabled} // Disable when transparent

                            value={
                              settings.enabled ?
                                settings?.customSettings?.highlight?.borderColor || "#000000" :
                                settings?.customSettings?.highlight?.borderColor || "#000000"
                            }
                            onChange={(e) => handleChange('highlight.borderColor', e.target.value)}
                          /> */}
                        </div>
                      </div>

                      <div className="col-md-4">
                        <div className="form-group">
                          <label className="d-flex align-items-center" style={{ height: '21px' }}>
                            Highlight fills color: (Transparent
                            <input
                              type="checkbox"
                              className="ml-1 mr-1"
                              disabled={settings?.customSettings?.pngBtnenabled}
                              checked={
                                settings?.customSettings?.highlight?.fillColor === 'transparent'
                              }
                              onChange={e =>
                                handleChange(
                                  'highlight.fillColor',
                                  e.target.checked ? 'transparent' : '#00000'
                                )
                              }
                            />
                            )
                          </label>

                          <MuiColorInput
                            className="form-control mt-1"
                            format="hex"
                            value={
                              settings?.customSettings?.highlight?.fillColor === 'transparent'
                                ? ''
                                : settings?.customSettings?.highlight?.fillColor
                            }
                            onChange={newHex =>
                              handleChange(
                                'highlight.fillColor',
                                newHex?.toUpperCase?.() || '#000000'
                              )
                            }
                            fallbackValue="#000000"
                            disabled={
                              settings?.customSettings?.highlight?.fillColor === 'transparent' ||
                              settings?.customSettings?.pngBtnenabled
                            }
                            // size="small"
                            isAlphaHidden={true} // This disables the alpha slider
                            sx={{
                              '& .MuiOutlinedInput-root': {
                                borderRadius: '0px !important',
                                height: 53,
                              },
                              '& .MuiOutlinedInput-input': {
                                height: '36px',
                              },
                              '& .MuiColorInput-Button': {
                                width: '49px !important', // Increase width
                                height: '40px !important',
                              },
                              '& .MuiInputAdornment-root .MuiBox-root': {
                                width: 18,
                                height: 18,
                              },
                            }}
                          />

                          {/* <input
                            type="color"
                            disabled={settings?.customSettings?.highlight?.fillColor === "transparent" || settings?.customSettings?.pngBtnenabled} // Disable when transparent
                            className="form-control"
                            value={
                              settings.enabled ?
                                settings?.customSettings?.highlight?.fillColor || "#000000" :
                                settings?.customSettings?.highlight?.fillColor || "#000000"
                            }
                            onChange={(e) => handleChange('highlight.fillColor', e.target.value)}
                          /> */}
                        </div>
                      </div>

                      <div className="col-md-4">
                        <div className="form-group">
                          <label className="d-flex align-items-center" style={{ height: '25px' }}>
                            Highlight Font color: (Transparent
                            <input
                              type="checkbox"
                              className="ml-1 mr-1"
                              disabled={settings?.customSettings?.pngBtnenabled}
                              checked={
                                settings?.customSettings?.highlight?.fontColor === 'transparent'
                              }
                              onChange={e =>
                                handleChange(
                                  'highlight.fontColor',
                                  e.target.checked ? 'transparent' : '#00000'
                                )
                              }
                            />
                            )
                          </label>

                          <MuiColorInput
                            className="form-control mt-1"
                            format="hex"
                            value={
                              settings?.customSettings?.highlight?.fontColor === 'transparent'
                                ? ''
                                : settings?.customSettings?.highlight?.fontColor
                            }
                            onChange={newHex =>
                              handleChange(
                                'highlight.fontColor',
                                newHex?.toUpperCase?.() || '#000000'
                              )
                            }
                            fallbackValue="#000000"
                            disabled={
                              settings?.customSettings?.highlight?.fontColor === 'transparent' ||
                              settings?.customSettings?.pngBtnenabled
                            }
                            // size="small"
                            isAlphaHidden={true} // This disables the alpha slider
                            sx={{
                              '& .MuiOutlinedInput-root': {
                                borderRadius: '0px !important',
                                height: 53,
                              },
                              '& .MuiOutlinedInput-input': {
                                height: '36px',
                              },
                              '& .MuiColorInput-Button': {
                                width: '49px !important', // Increase width
                                height: '40px !important',
                              },
                              '& .MuiInputAdornment-root .MuiBox-root': {
                                width: 18,
                                height: 18,
                              },
                            }}
                          />

                          {/* <input
                            type="color"
                            className="form-control"
                            disabled={settings?.customSettings?.highlight?.fontColor === "transparent" || settings?.customSettings?.pngBtnenabled} // Disable when transparent
                            value={
                              settings.enabled ?
                                settings?.customSettings?.highlight?.fontColor || "#000000" :
                                settings?.customSettings?.highlight?.fontColor || "#000000"
                            }
                            onChange={(e) => handleChange('highlight.fontColor', e.target.value)}
                          /> */}
                        </div>
                      </div>
                    </div>

                    {/* click Sound */}

                    <div className="row ">
                      <div className="col-md-6 ">
                        {/* <div className="form-group">            
              
              <input type="file" onChange={handleFileChange} />
              {file ? <button style={{backgroundColor:buttonColor}} type="button" onClick={handleUpload}>Upload</button> :""}        
              <div>                   
                    <a href={settings.enabled ? settings?.customSettings?.clickSound : settings?.customSettings?.clickSound} 
                     target='_blank'
                     rel="noreferrer"
                     >
                    {settings.enabled ? settings?.customSettings?.clickSoundFilename : settings?.customSettings?.clickSoundFilename}                    
                  </a>
              </div>
            
            </div> */}

                        <div className={`form-group menu-card2 `} style={{}}>
                          <label>Upload Click Sound:</label>

                          <MediaDropzone
                            onDrop={createDropHandler(setBtnSound)}
                            selectedFile={btnSound}
                          />
                          <UploadButton
                            uploading={uploadingStates?.btnSound}
                            onUpload={() => handleUpload('btnSound', btnSound)}
                            buttonColor={buttonColor}
                          />

                          <div style={{ marginTop: '5px' }}>
                            Uploaded File:{' '}
                            <a
                              href={settings?.customSettings?.clickSound}
                              style={{ fontWeight: 'bold' }}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              {settings?.customSettings?.clickSoundFilename}
                            </a>
                          </div>
                          {/* <UploadedUrlQr url={settings?.customSettings?.clickSound} /> */}
                        </div>
                      </div>

                      <div className="col-md-6 ">
                        <div className={`form-group menu-card2 `} style={{}}>
                          <label>Upload Button png:</label>

                          <MediaDropzone
                            onDrop={createDropHandler(setBtnPng)}
                            selectedFile={btnPng}
                          />
                          <UploadButton
                            uploading={uploadingStates?.btnPng}
                            onUpload={() => handleUpload('btnPng', btnPng)}
                            buttonColor={buttonColor}
                          />

                          <div style={{ marginTop: '5px' }}>
                            Uploaded File:{' '}
                            <a
                              href={
                                typeof settings?.customSettings?.btnPng === 'object'
                                  ? settings?.customSettings?.btnPng?.[currentLanguage] || settings?.customSettings?.btnPng?.['en']
                                  : settings?.customSettings?.btnPng
                              }
                              style={{ fontWeight: 'bold' }}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              {
                                typeof settings?.customSettings?.btnPngFileName === 'object'
                                  ? settings?.customSettings?.btnPngFileName?.[currentLanguage] || settings?.customSettings?.btnPngFileName?.['en']
                                  : settings?.customSettings?.btnPngFileName
                              }
                            </a>
                          </div>
                          {/* <UploadedUrlQr url={settings?.customSettings?.clickSound} /> */}
                        </div>
                      </div>
                    </div>

                    {/* Icon Upload Section */}
                    {settings?.enabled && settings?.customSettings?.enableIcon && (
                      <div className="row">
                        <div className="col-md-6">
                          <div className={`form-group menu-card2`}>
                            <label>Upload Button Icon:</label>

                            <MediaDropzone
                              onDrop={createDropHandler(setBtnIcon)}
                              selectedFile={btnIcon}
                            />
                            <UploadButton
                              uploading={uploadingStates?.btnIcon}
                              onUpload={handleUploadIcon}
                              buttonColor={buttonColor}
                            />

                            <div className="form-group" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                              <div>
                                <div style={{ marginTop: "5px" }}>
                                  Uploaded File:{" "}
                                  <a
                                    href={settings?.customSettings?.buttonIcon}
                                    style={{ fontWeight: "bold" }}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    {settings?.customSettings?.buttonIconFileName}
                                  </a>
                                </div>
                              </div>

                              <div
                                className="dimensions"
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                  gap: "15px",
                                  height: "100%",
                                }}
                              >
                                {/* Size Input */}
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "8px",
                                  }}
                                >
                                  <label
                                    style={{
                                      fontWeight: "600",
                                      whiteSpace: "nowrap",
                                      fontSize: "14px",
                                    }}
                                  >
                                    Size (%):
                                  </label>
                                  <input
                                    type="number"
                                    className="form-control"
                                    value={
                                      settings.enabled
                                        ? (settings?.customSettings?.iconSize ?? 90)
                                        : (settings?.globalSettings?.iconSize ?? 90)
                                    }
                                    min="0"
                                    max="100"
                                    onChange={(e) =>
                                      handleChange("iconSize", Number(e.target.value))
                                    }
                                    placeholder="Size"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className={`form-group menu-card2`}>
                            <label>Icon Position Settings:</label>
                            
                            <div className="row" style={{ marginTop: "10px" }}>
                              <div className="col-md-12">
                                <div className="form-group">
                                  <label>Icon Position:</label>
                                  <select
                                    value={
                                      settings.enabled
                                        ? (settings?.customSettings?.iconPosition ?? 'top')
                                        : (settings?.globalSettings?.iconPosition ?? 'top')
                                    }
                                    onChange={(e) => handleChange("iconPosition", e.target.value)}
                                    className="form-select form-control"
                                  >
                                    <option value="left">Left</option>
                                    <option value="top">Top (Center)</option>
                                    <option value="right">Right</option>
                                    <option value="bottom">Bottom (Center)</option>
                                  </select>
                                </div>
                              </div>

                              <div className="col-md-12">
                                <div className="form-group">
                                  <label>Icon Spacing (px):</label>
                                  <input
                                    type="number"
                                    className="form-control"
                                    value={
                                      settings.enabled
                                        ? (settings?.customSettings?.iconSpacing ?? 8)
                                        : (settings?.globalSettings?.iconSpacing ?? 8)
                                    }
                                    min="0"
                                    max="50"
                                    onChange={(e) =>
                                      handleChange("iconSpacing", Number(e.target.value))
                                    }
                                  />
                                  <small style={{ color: "#666" }}>
                                    Space between icon and text
                                  </small>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}

                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>
                            Click sound volume <strong>(The volume range should be 0 to 1)</strong>:
                          </label>
                          <input
                            type="number"
                            className="form-control"
                            value={
                              settings.enabled
                                ? (settings?.customSettings?.clickSoundVolume ?? 0)
                                : (settings?.customSettings?.clickSoundVolume ?? 0)
                            }
                            min="0"
                            max="1"
                            step="0.1"
                            onChange={e => {
                              let value = Number(e.target.value);
                              if (value < 0) value = 0;
                              if (value > 1) value = 1;
                              handleChange('clickSoundVolume', value);
                            }}
                          />
                        </div>
                      </div>
                    </div>

                    {settings?.enabled && (
                      <button style={{ backgroundColor: buttonColor }} type="submit">
                        Save Settings
                      </button>
                    )}
                  </form>
                </>
              )}

              <form
                className="tab-wizard wizard-circle wizard vertical"
                onSubmit={handleSubmitPage}
              >
                {value === 1 && (
                  <>
                    <div
                      className="col d-flex justify-content-between"
                      style={{ marginLeft: '5px' }}
                    >
                      {/* <ToggleSwitch 
                label="Enable Back to Menu Button"
                isOn={menuBackButton}
                onChange={()=>setMenuBackButton(!menuBackButton)}
                id="backbutton"
                /> */}

                      <div
                        style={{
                          marginTop: '10px',
                          display: 'inline-flex',
                          gap: '26px',
                        }}
                      >
                        <div className="setting form-group custom-control custom-radio">
                          <input
                            type="radio"
                            value="video"
                            id={`video-content-${id}`}
                            className="custom-control-input"
                            name="contenttype"
                            checked={menuContent === 'video'}
                            onChange={() => setMenuContent('video')}
                          />
                          <label className="custom-control-label" htmlFor={`video-content-${id}`}>
                            Video Content
                          </label>
                        </div>
                        <div className="setting form-group custom-control custom-radio">
                          <input
                            type="radio"
                            value="weblink"
                            className="custom-control-input"
                            name="contenttype"
                            checked={menuContent === 'weblink'}
                            onChange={() => setMenuContent('weblink')}
                            id={`weblink-${id}`}
                          />

                          <label className="custom-control-label" htmlFor={`weblink-${id}`}>
                            External Web Link
                          </label>
                        </div>
                      </div>
                    </div>

                    <div className="row ">
                      {/* Left Top Media */}
                      <div className="col-md-6 d-flex p-3">
                        <div
                          className={`form-group menu-card2 ${!uploadedUrls?.leftTop?.enabled ? 'disabled' : ''} h-100 w-100`}
                          style={{
                            height: 'auto',
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '5px',
                            justifyContent: 'space-around',
                          }}
                        >
                          <div className="form-group">
                            <label>Upper Left Media:</label>
                            <ToggleSwitch
                              label="Enable"
                              isOn={uploadedUrls.leftTop.enabled}
                              id={'leftTop'}
                              onChange={value => handleToggleChangeMedia('leftTop', value)}
                            />
                          </div>

                          <div
                            style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '5px' }}
                          >
                            <MediaDropzone
                              onDrop={createDropHandler(setLeftTopMedia)}
                              selectedFile={leftTopMedia}
                            />

                            <UploadedUrlImage url={uploadedUrls.leftTop} />
                          </div>

                          <div>
                            <UploadedUrl
                              url={uploadedUrls.leftTop}
                              buttonColor={buttonColor}
                              deleteFile={() =>
                                deleteFile(uploadedUrls?.leftTop?.fileUrl, 'leftTop')
                              }
                            />
                          </div>

                          <div
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'space-between',
                              gap: '20px',
                              width: '100%',
                              padding: '10px 0',
                            }}
                          >
                            {/* LEFT - Upload button */}
                            <div
                              style={{
                                flex: '1',
                                display: 'flex',
                                justifyContent: 'start',
                                height: '100%',
                              }}
                            >
                              <UploadButton
                                uploading={uploadingStates.leftTop}
                                onUpload={() => handleUploadContent(leftTopMedia, 'leftTop')}
                                buttonColor={buttonColor}
                                style={{ height: '100%', margin: '0' }}
                              />
                            </div>

                            {/* MIDDLE - Checkboxes */}
                            <div
                              style={{
                                flex: '1',
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'center',
                                gap: '5px',
                                height: '100%',
                              }}
                            >
                              <div
                                className="setting custom-control custom-checkbox"
                                style={{ margin: '0' }}
                              >
                                <input
                                  type="checkbox"
                                  checked={uploadedUrls.leftTop.disabledPadding}
                                  onChange={e =>
                                    setUploadedUrls({
                                      ...uploadedUrls,
                                      leftTop: {
                                        ...uploadedUrls.leftTop,
                                        disabledPadding: e.target.checked,
                                      },
                                    })
                                  }
                                  id={`disable_padding_leftTop`}
                                  className="custom-control-input"
                                  style={{ height: 'auto' }}
                                />
                                <label
                                  className="custom-control-label"
                                  htmlFor={`disable_padding_leftTop`}
                                  style={{ marginBottom: '0' }}
                                >
                                  Disable Top Margin
                                </label>
                              </div>

                              <div
                                className="setting custom-control custom-checkbox"
                                style={{ margin: '0', paddingBottom: '0' }}
                              >
                                <input
                                  type="checkbox"
                                  checked={uploadedUrls.leftTop.disabledMargin}
                                  onChange={e =>
                                    setUploadedUrls({
                                      ...uploadedUrls,
                                      leftTop: {
                                        ...uploadedUrls.leftTop,
                                        disabledMargin: e.target.checked,
                                      },
                                    })
                                  }
                                  id={`disable_marginLeft_leftTop`}
                                  className="custom-control-input"
                                  style={{ height: 'auto' }}
                                />
                                <label
                                  className="custom-control-label"
                                  htmlFor={`disable_marginLeft_leftTop`}
                                  style={{ marginBottom: '0' }}
                                >
                                  Disable Left Margin
                                </label>
                              </div>
                            </div>

                            {/* RIGHT - Size input */}
                            <div
                              style={{
                                flex: '1',
                                display: 'flex',
                                justifyContent: 'end',
                                alignItems: 'center',
                                height: '100%',
                              }}
                            >
                              <div
                                style={{
                                  width: '70%',
                                  display: 'flex',
                                  alignItems: 'center',
                                  gap: '10px',
                                  height: '100%',
                                }}
                              >
                                <label style={{ fontWeight: '600', whiteSpace: 'nowrap', margin: '0' }}>
                                  Size (%):
                                </label>
                                <input
                                  type="number"
                                  style={{ width: '100%', height: '100%' }}
                                  value={uploadedUrls.leftTop.width}
                                  onChange={e =>
                                    setUploadedUrls({
                                      ...uploadedUrls,
                                      leftTop: {
                                        ...uploadedUrls.leftTop,
                                        width: Number(e.target.value),
                                      },
                                    })
                                  }
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Right Top Media */}
                      {/* <div className="col-md-6 ">
                        <div
                          className={`form-group menu-card2 ${!uploadedUrls?.rightTop?.enabled ? 'disabled' : ''}`}
                          style={{ height: '463px' }}
                        >
                          <label>Upper Right Media:</label>
                          <ToggleSwitch
                            label="Enable"
                            isOn={uploadedUrls.rightTop.enabled}
                            onChange={val => handleToggleChangeMedia('rightTop', val)}
                            id={'rightTop'}
                          />
                          <MediaDropzone
                            onDrop={createDropHandler(setRightTopMedia)}
                            selectedFile={rightTopMedia}
                          />
                          <UploadButton
                            uploading={uploadingStates.rightTop}
                            onUpload={() => handleUploadContent(rightTopMedia, 'rightTop')}
                            buttonColor={buttonColor}
                          />
                          <UploadedUrl
                            url={uploadedUrls.rightTop}
                            buttonColor={buttonColor}
                            deleteFile={() =>
                              deleteFile(uploadedUrls?.rightTop?.fileUrl, 'rightTop')
                            }
                          />

                          <div
                            className="dimensions"
                            style={{
                              gap: '18px',
                              marginTop: '10px',
                              display: 'flex',
                            }}
                          >
                            <label>
                              Screen Width(%):
                              <input
                                type="number"
                                value={uploadedUrls.rightTop.width}
                                onChange={e =>
                                  setUploadedUrls({
                                    ...uploadedUrls,
                                    rightTop: {
                                      ...uploadedUrls.rightTop,
                                      width: Number(e.target.value),
                                    },
                                  })
                                }
                              />
                            </label>
                            <label style={{ display: 'none' }}>
                              Height:
                              <input
                                type="number"
                                value={uploadedUrls.rightTop.height}
                                onChange={e =>
                                  setUploadedUrls({
                                    ...uploadedUrls,
                                    rightTop: {
                                      ...uploadedUrls.rightTop,
                                      height: Number(e.target.value),
                                    },
                                  })
                                }
                              />
                            </label>
                          </div>
                          <small style={{ color: '#000000' }}>
                            Note: The <code>height</code> will be set to the same aspect ratio as
                            the graphic
                          </small>
                        </div>
                      </div> */}

                      <div className="col-md-6 d-flex p-3">
                        <div
                          className={`form-group menu-card2 ${!uploadedUrls?.rightTop?.enabled ? 'disabled' : ''} h-100 w-100`}
                          style={{
                            height: 'auto',
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'space-around',
                            gap: '5px',
                          }}
                        >
                          {/* ENABLE TOGGLE */}
                          <div className="form-group">
                            <label>Upper Right Media:</label>
                            <ToggleSwitch
                              label="Enable"
                              isOn={uploadedUrls.rightTop.enabled}
                              id={'rightTop'}
                              onChange={value => handleToggleChangeMedia('rightTop', value)}
                            />
                          </div>

                          {/* DROPZONE + PREVIEW IMAGE SIDE BY SIDE */}
                          <div
                            style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '5px' }}
                          >
                            <MediaDropzone
                              onDrop={createDropHandler(setRightTopMedia)}
                              selectedFile={rightTopMedia}
                            />

                            <UploadedUrlImage url={uploadedUrls.rightTop} />
                          </div>

                          {/* URL LIST */}
                          <div>
                            <UploadedUrl
                              url={uploadedUrls.rightTop}
                              buttonColor={buttonColor}
                              deleteFile={() =>
                                deleteFile(uploadedUrls?.rightTop?.fileUrl, 'rightTop')
                              }
                            />
                          </div>

                          {/* BUTTON + CHECKBOXES + WIDTH SENSOR */}
                          <div
                            style={{
                              display: 'flex',
                              justifyContent: 'space-between',
                              alignItems: 'center',
                            }}
                          >
                            {/* UPLOAD BUTTON */}
                            <UploadButton
                              uploading={uploadingStates.rightTop}
                              onUpload={() => handleUploadContent(rightTopMedia, 'rightTop')}
                              buttonColor={buttonColor}
                              style={{ margin: '0' }}
                            />

                            {/* CHECKBOXES */}
                            <div
                              className="dimensions"
                              style={{
                                display: 'flex',
                                flexDirection: 'column',
                                gap: '10px',
                              }}
                            >
                              <div
                                className="setting form-group custom-control custom-checkbox"
                                style={{ marginBottom: '0px', display: 'none' }}
                              >
                                <input
                                  type="checkbox"
                                  checked={uploadedUrls.rightTop.disabledPadding}
                                  onChange={e =>
                                    setUploadedUrls({
                                      ...uploadedUrls,
                                      rightTop: {
                                        ...uploadedUrls.rightTop,
                                        disabledPadding: e.target.checked,
                                      },
                                    })
                                  }
                                  id={`disable_padding_rightTop`}
                                  className="custom-control-input"
                                />

                                <label
                                  className="custom-control-label"
                                  htmlFor={`disable_padding_rightTop`}
                                >
                                  Disable Top Margin
                                </label>
                              </div>

                              <div
                                className="setting form-group custom-control custom-checkbox"
                                style={{ marginBottom: '0px', display: 'none' }}
                              >
                                <input
                                  type="checkbox"
                                  checked={uploadedUrls.rightTop.disabledMargin}
                                  onChange={e =>
                                    setUploadedUrls({
                                      ...uploadedUrls,
                                      rightTop: {
                                        ...uploadedUrls.rightTop,
                                        disabledMargin: e.target.checked,
                                      },
                                    })
                                  }
                                  id={`disable_marginLeft_rightTop`}
                                  className="custom-control-input"
                                />

                                <label
                                  className="custom-control-label"
                                  htmlFor={`disable_marginLeft_rightTop`}
                                >
                                  Disable Left Margin
                                </label>
                              </div>
                            </div>

                            {/* SIZE INPUT */}

                            <div
                              style={{
                                // flex: '1',
                                display: 'flex',
                                justifyContent: 'end',
                                alignItems: 'center',
                                height: '100%',
                              }}
                            >
                              <div
                                style={{
                                  width: '60%',
                                  display: 'flex',
                                  alignItems: 'center',
                                  gap: '10px',
                                  height: '100%',
                                }}
                              >
                                <label style={{ fontWeight: '600', whiteSpace: 'nowrap', margin: '0' }}>
                                  Size (%):
                                </label>

                                <input
                                  style={{ width: '100%', height: '100%' }}
                                  type="number"
                                  value={uploadedUrls.rightTop.width}
                                  onChange={e =>
                                    setUploadedUrls({
                                      ...uploadedUrls,
                                      rightTop: {
                                        ...uploadedUrls.rightTop,
                                        width: Number(e.target.value),
                                      },
                                    })
                                  }
                                />
                              </div>

                              <label style={{ display: 'none' }}>
                                Height:
                                <input
                                  type="number"
                                  value={uploadedUrls.rightTop.height}
                                  onChange={e =>
                                    setUploadedUrls({
                                      ...uploadedUrls,
                                      rightTop: {
                                        ...uploadedUrls.rightTop,
                                        height: Number(e.target.value),
                                      },
                                    })
                                  }
                                />
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="row ">
                      {/* Left Bottom Media */}
                      {/* <div className="col-md-6 ">
                        <div
                          className={`form-group menu-card2 ${!uploadedUrls?.leftBottom?.enabled ? 'disabled' : ''}`}
                          style={{ height: '463px' }}
                        >
                          <label>Lower Left Media:</label>
                          <ToggleSwitch
                            label="Enable"
                            isOn={uploadedUrls.leftBottom.enabled}
                            id={'leftBottom'}
                            onChange={value => handleToggleChangeMedia('leftBottom', value)}
                          />
                          <MediaDropzone
                            onDrop={createDropHandler(setLeftBottomMedia)}
                            selectedFile={leftBottomMedia}
                          />
                          <UploadButton
                            uploading={uploadingStates.leftBottom}
                            onUpload={() => handleUploadContent(leftBottomMedia, 'leftBottom')}
                            buttonColor={buttonColor}
                          />
                          <UploadedUrl
                            url={uploadedUrls.leftBottom}
                            buttonColor={buttonColor}
                            deleteFile={() =>
                              deleteFile(uploadedUrls?.leftBottom?.fileUrl, 'leftBottom')
                            }
                          />

                          <div
                            className="dimensions"
                            style={{
                              gap: '18px',
                              marginTop: '10px',
                              display: 'flex',
                            }}
                          >
                            <label>
                              Screen Width(%):
                              <input
                                type="number"
                                value={uploadedUrls.leftBottom.width}
                                onChange={e =>
                                  setUploadedUrls({
                                    ...uploadedUrls,
                                    leftBottom: {
                                      ...uploadedUrls.leftBottom,
                                      width: Number(e.target.value),
                                    },
                                  })
                                }
                              />
                            </label>
                            <label style={{ display: 'none' }}>
                              Height:
                              <input
                                type="number"
                                value={uploadedUrls.leftBottom.height}
                                onChange={e =>
                                  setUploadedUrls({
                                    ...uploadedUrls,
                                    leftBottom: {
                                      ...uploadedUrls.leftBottom,
                                      height: Number(e.target.value),
                                    },
                                  })
                                }
                              />
                            </label>
                          </div>
                          <small style={{ color: '#000000' }}>
                            Note: The <code>height</code> will be set to the same aspect ratio as
                            the graphic
                          </small>
                        </div>
                      </div> */}

                      <div className="col-md-6 d-flex p-3">
                        <div
                          className={`form-group menu-card2 ${!uploadedUrls?.leftBottom?.enabled ? 'disabled' : ''} h-100 w-100`}
                          style={{
                            height: 'auto',
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'space-around',
                            gap: '5px',
                          }}
                        >
                          {/* ENABLE TOGGLE */}
                          <div className="form-group">
                            <label>Lower Left Media:</label>
                            <ToggleSwitch
                              label="Enable"
                              isOn={uploadedUrls.leftBottom.enabled}
                              id={'leftBottom'}
                              onChange={value => handleToggleChangeMedia('leftBottom', value)}
                            />
                          </div>

                          {/* DROPZONE + PREVIEW */}
                          <div
                            style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '5px' }}
                          >
                            <MediaDropzone
                              onDrop={createDropHandler(setLeftBottomMedia)}
                              selectedFile={leftBottomMedia}
                            />

                            <UploadedUrlImage url={uploadedUrls.leftBottom} />
                          </div>

                          {/* UPLOADED URL LIST */}
                          <div>
                            <UploadedUrl
                              url={uploadedUrls.leftBottom}
                              buttonColor={buttonColor}
                              deleteFile={() =>
                                deleteFile(uploadedUrls?.leftBottom?.fileUrl, 'leftBottom')
                              }
                            />
                          </div>

                          {/* BUTTON + SETTINGS SECTION */}
                          <div
                            style={{
                              display: 'flex',
                              justifyContent: 'space-between',
                              alignItems: 'center',
                            }}
                          >
                            {/* UPLOAD BUTTON */}
                            <UploadButton
                              uploading={uploadingStates.leftBottom}
                              onUpload={() => handleUploadContent(leftBottomMedia, 'leftBottom')}
                              buttonColor={buttonColor}
                              style={{ margin: '0' }}
                            />

                            {/* CHECKBOXES */}
                            <div
                              className="dimensions"
                              style={{
                                display: 'flex',
                                flexDirection: 'column',
                                gap: '10px',
                              }}
                            >
                              <div
                                className="setting form-group custom-control custom-checkbox"
                                style={{ marginBottom: '0px', display: 'none' }}
                              >
                                <input
                                  type="checkbox"
                                  checked={uploadedUrls.leftBottom.disabledPadding}
                                  onChange={e =>
                                    setUploadedUrls({
                                      ...uploadedUrls,
                                      leftBottom: {
                                        ...uploadedUrls.leftBottom,
                                        disabledPadding: e.target.checked,
                                      },
                                    })
                                  }
                                  id={`disable_padding_leftBottom`}
                                  className="custom-control-input"
                                />

                                <label
                                  className="custom-control-label"
                                  htmlFor={`disable_padding_leftBottom`}
                                >
                                  Disable Top Margin
                                </label>
                              </div>

                              <div
                                className="setting form-group custom-control custom-checkbox"
                                style={{ marginBottom: '0px', display: 'none' }}
                              >
                                <input
                                  type="checkbox"
                                  checked={uploadedUrls.leftBottom.disabledMargin}
                                  onChange={e =>
                                    setUploadedUrls({
                                      ...uploadedUrls,
                                      leftBottom: {
                                        ...uploadedUrls.leftBottom,
                                        disabledMargin: e.target.checked,
                                      },
                                    })
                                  }
                                  id={`disable_marginLeft_leftBottom`}
                                  className="custom-control-input"
                                />

                                <label
                                  className="custom-control-label"
                                  htmlFor={`disable_marginLeft_leftBottom`}
                                >
                                  Disable Left Margin
                                </label>
                              </div>
                            </div>

                            {/* WIDTH INPUT */}
                            <div
                              style={{
                                // flex: '1',
                                display: 'flex',
                                justifyContent: 'end',
                                alignItems: 'center',
                                height: '100%',
                              }}
                            >
                              <div
                                style={{
                                  width: '60%',
                                  display: 'flex',
                                  alignItems: 'center',
                                  gap: '10px',
                                  height: '100%',
                                }}
                              >
                                <label style={{ fontWeight: '600', whiteSpace: 'nowrap', margin: '0' }}>
                                  Size (%):
                                </label>

                                <input
                                  type="number"
                                  style={{ width: '100%', height: '100%' }}
                                  value={uploadedUrls.leftBottom.width}
                                  onChange={e =>
                                    setUploadedUrls({
                                      ...uploadedUrls,
                                      leftBottom: {
                                        ...uploadedUrls.leftBottom,
                                        width: Number(e.target.value),
                                      },
                                    })
                                  }
                                />
                              </div>

                              <label style={{ display: 'none' }}>
                                Height:
                                <input
                                  type="number"
                                  value={uploadedUrls.leftBottom.height}
                                  onChange={e =>
                                    setUploadedUrls({
                                      ...uploadedUrls,
                                      leftBottom: {
                                        ...uploadedUrls.leftBottom,
                                        height: Number(e.target.value),
                                      },
                                    })
                                  }
                                />
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Right Bottom Media */}
                      {/* <div className="col-md-6 ">
                        <div
                          className={`form-group menu-card2 ${!uploadedUrls?.rightBottom?.enabled ? 'disabled' : ''}`}
                          style={{ height: '463px' }}
                        >
                          <label>Lower Right Media:</label>
                          <ToggleSwitch
                            label="Enable"
                            isOn={uploadedUrls.rightBottom.enabled}
                            onChange={val => handleToggleChangeMedia('rightBottom', val)}
                            id={'rightBottom'}
                          />
                          <MediaDropzone
                            onDrop={createDropHandler(setRightBottomMedia)}
                            selectedFile={rightBottomMedia}
                          />
                          <UploadButton
                            uploading={uploadingStates.rightBottom}
                            onUpload={() => handleUploadContent(rightBottomMedia, 'rightBottom')}
                            buttonColor={buttonColor}
                          />
                          <UploadedUrl
                            url={uploadedUrls.rightBottom}
                            buttonColor={buttonColor}
                            deleteFile={() =>
                              deleteFile(uploadedUrls?.rightBottom?.fileUrl, 'rightBottom')
                            }
                          />

                          <div
                            className="dimensions"
                            style={{
                              gap: '18px',
                              marginTop: '10px',
                              display: 'flex',
                            }}
                          >
                            <label>
                              Screen Width(%):
                              <input
                                type="number"
                                value={uploadedUrls.rightBottom.width}
                                onChange={e =>
                                  setUploadedUrls({
                                    ...uploadedUrls,
                                    rightBottom: {
                                      ...uploadedUrls.rightBottom,
                                      width: Number(e.target.value),
                                    },
                                  })
                                }
                              />
                            </label>
                            <label style={{ display: 'none' }}>
                              Height:
                              <input
                                type="number"
                                value={uploadedUrls.rightBottom.height}
                                onChange={e =>
                                  setUploadedUrls({
                                    ...uploadedUrls,
                                    rightBottom: {
                                      ...uploadedUrls.rightBottom,
                                      height: Number(e.target.value),
                                    },
                                  })
                                }
                              />
                            </label>
                          </div>
                          <small style={{ color: '#000000' }}>
                            Note: The <code>height</code> will be set to the same aspect ratio as
                            the graphic
                          </small>
                        </div>
                      </div> */}

                      <div className="col-md-6 d-flex p-3">
                        <div
                          className={`form-group menu-card2 ${!uploadedUrls?.rightBottom?.enabled ? 'disabled' : ''} h-100 w-100`}
                          style={{
                            height: 'auto',
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'space-around',
                            gap: '5px',
                          }}
                        >
                          {/* ENABLE TOGGLE */}
                          <div className="form-group">
                            <label>Lower Right Media:</label>
                            <ToggleSwitch
                              label="Enable"
                              isOn={uploadedUrls.rightBottom.enabled}
                              id={'rightBottom'}
                              onChange={value => handleToggleChangeMedia('rightBottom', value)}
                            />
                          </div>

                          {/* DROPZONE + PREVIEW */}
                          <div
                            style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '5px' }}
                          >
                            <MediaDropzone
                              onDrop={createDropHandler(setRightBottomMedia)}
                              selectedFile={rightBottomMedia}
                            />

                            <UploadedUrlImage url={uploadedUrls.rightBottom} />
                          </div>

                          {/* UPLOADED URL LIST */}
                          <div>
                            <UploadedUrl
                              url={uploadedUrls.rightBottom}
                              buttonColor={buttonColor}
                              deleteFile={() =>
                                deleteFile(uploadedUrls?.rightBottom?.fileUrl, 'rightBottom')
                              }
                            />
                          </div>

                          {/* BUTTON + CHECKBOXES + WIDTH */}
                          <div
                            style={{
                              display: 'flex',
                              justifyContent: 'space-between',
                              alignItems: 'center',
                            }}
                          >
                            {/* UPLOAD BUTTON */}
                            <UploadButton
                              uploading={uploadingStates.rightBottom}
                              onUpload={() => handleUploadContent(rightBottomMedia, 'rightBottom')}
                              buttonColor={buttonColor} style={{ margin: '0' }}
                            />

                            {/* CHECKBOXES */}
                            <div
                              className="dimensions"
                              style={{
                                display: 'flex',
                                flexDirection: 'column',
                                gap: '10px',
                              }}
                            >
                              <div
                                className="setting form-group custom-control custom-checkbox"
                                style={{ marginBottom: '0px', display: 'none' }}
                              >
                                <input
                                  type="checkbox"
                                  checked={uploadedUrls.rightBottom.disabledPadding}
                                  onChange={e =>
                                    setUploadedUrls({
                                      ...uploadedUrls,
                                      rightBottom: {
                                        ...uploadedUrls.rightBottom,
                                        disabledPadding: e.target.checked,
                                      },
                                    })
                                  }
                                  id={`disable_padding_rightBottom`}
                                  className="custom-control-input"
                                />

                                <label
                                  className="custom-control-label"
                                  htmlFor={`disable_padding_rightBottom`}
                                >
                                  Disable Top Margin
                                </label>
                              </div>

                              <div
                                className="setting form-group custom-control custom-checkbox"
                                style={{ marginBottom: '0px', display: 'none' }}
                              >
                                <input
                                  type="checkbox"
                                  checked={uploadedUrls.rightBottom.disabledMargin}
                                  onChange={e =>
                                    setUploadedUrls({
                                      ...uploadedUrls,
                                      rightBottom: {
                                        ...uploadedUrls.rightBottom,
                                        disabledMargin: e.target.checked,
                                      },
                                    })
                                  }
                                  id={`disable_marginLeft_rightBottom`}
                                  className="custom-control-input"
                                />

                                <label
                                  className="custom-control-label"
                                  htmlFor={`disable_marginLeft_rightBottom`}
                                >
                                  Disable Left Margin
                                </label>
                              </div>
                            </div>

                            {/* WIDTH INPUT */}

                            <div
                              style={{
                                // flex: '1',
                                display: 'flex',
                                justifyContent: 'end',
                                alignItems: 'center',
                                height: '100%',
                              }}
                            >
                              <div
                                style={{
                                  width: '60%',
                                  display: 'flex',
                                  alignItems: 'center',
                                  gap: '10px',
                                  height: '100%',
                                }}
                              >
                                <label style={{ fontWeight: '600', whiteSpace: 'nowrap', margin: '0' }}>
                                  Size (%):
                                </label>

                                <input
                                  type="number"
                                  style={{ width: '100%', height: '100%' }}
                                  value={uploadedUrls.rightBottom.width}
                                  onChange={e =>
                                    setUploadedUrls({
                                      ...uploadedUrls,
                                      rightBottom: {
                                        ...uploadedUrls.rightBottom,
                                        width: Number(e.target.value),
                                      },
                                    })
                                  }
                                />
                              </div>

                              <label style={{ display: 'none' }}>
                                Height:
                                <input
                                  type="number"
                                  value={uploadedUrls.rightBottom.height}
                                  onChange={e =>
                                    setUploadedUrls({
                                      ...uploadedUrls,
                                      rightBottom: {
                                        ...uploadedUrls.rightBottom,
                                        height: Number(e.target.value),
                                      },
                                    })
                                  }
                                />
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      {/* <div className="col-md-6 ">
                        <div
                          className={`form-group menu-card2 ${!uploadedUrls?.centerBelowMenuMedia?.enabled ? 'disabled' : ''}`}
                        >
                          <label>Lower Center Menu Media</label>
                          <ToggleSwitch
                            label="Enable"
                            isOn={uploadedUrls.centerBelowMenuMedia.enabled}
                            onChange={val => handleToggleChangeMedia('centerBelowMenuMedia', val)}
                            id={'centerBelowMenuMedia'}
                          />
                          <MediaDropzone
                            onDrop={createDropHandler(setCenterBelowMenuMedia)}
                            selectedFile={centerBelowMenuMedia}
                          />
                          <UploadButton
                            uploading={uploadingStates.centerBelowMenuMedia}
                            onUpload={() =>
                              handleUploadContent(centerBelowMenuMedia, 'centerBelowMenuMedia')
                            }
                            buttonColor={buttonColor}
                          />
                          <UploadedUrl
                            url={uploadedUrls.centerBelowMenuMedia}
                            buttonColor={buttonColor}
                            deleteFile={() =>
                              deleteFile(
                                uploadedUrls?.centerBelowMenuMedia?.fileUrl,
                                'centerBelowMenuMedia'
                              )
                            }
                          />

                          <div
                            className="dimensions"
                            style={{
                              gap: '18px',
                              marginTop: '10px',
                              display: 'flex',
                            }}
                          >
                            <label>
                              Screen Width(%):
                              <input
                                type="number"
                                value={uploadedUrls.centerBelowMenuMedia.width}
                                onChange={e =>
                                  setUploadedUrls({
                                    ...uploadedUrls,
                                    centerBelowMenuMedia: {
                                      ...uploadedUrls.centerBelowMenuMedia,
                                      width: Number(e.target.value),
                                    },
                                  })
                                }
                              />
                            </label>
                            <label style={{ display: 'none' }}>
                              Height:
                              <input
                                type="number"
                                value={uploadedUrls.centerBelowMenuMedia.height}
                                onChange={e =>
                                  setUploadedUrls({
                                    ...uploadedUrls,
                                    centerBelowMenuMedia: {
                                      ...uploadedUrls.centerBelowMenuMedia,
                                      height: Number(e.target.value),
                                    },
                                  })
                                }
                              />
                            </label>
                          </div>
                          <small style={{ color: '#000000' }}>
                            Note: The <code>height</code> will be set to the same aspect ratio as
                            the graphic
                          </small>
                        </div>
                      </div>

                      <div className="col-md-6 ">
                        <div
                          className={`form-group menu-card2 ${!uploadedUrls?.centerLogoMedia?.enabled ? 'disabled' : ''}`}
                        >
                          <label>Center Logo:</label>
                          <ToggleSwitch
                            label="Enable"
                            isOn={uploadedUrls.centerLogoMedia.enabled}
                            onChange={val => handleToggleChangeMedia('centerLogoMedia', val)}
                            id={'centerLogoMedia'}
                          />
                          <MediaDropzone
                            onDrop={createDropHandler(setCenterLogoMedia)}
                            selectedFile={centerLogoMedia}
                          />
                          <UploadButton
                            uploading={uploadingStates.centerLogoMedia}
                            onUpload={() => handleUploadContent(centerLogoMedia, 'centerLogoMedia')}
                            buttonColor={buttonColor}
                          />
                          <UploadedUrl
                            url={uploadedUrls.centerLogoMedia}
                            buttonColor={buttonColor}
                            deleteFile={() =>
                              deleteFile(uploadedUrls?.centerLogoMedia?.fileUrl, 'centerLogoMedia')
                            }
                          />

                          <div
                            className="dimensions"
                            style={{
                              gap: '18px',
                              marginTop: '10px',
                              display: 'flex',
                            }}
                          >
                            <label>
                              Screen Width(%):
                              <input
                                type="number"
                                value={uploadedUrls.centerLogoMedia.width}
                                onChange={e =>
                                  setUploadedUrls({
                                    ...uploadedUrls,
                                    centerLogoMedia: {
                                      ...uploadedUrls.centerLogoMedia,
                                      width: Number(e.target.value),
                                    },
                                  })
                                }
                              />
                            </label>
                            <label style={{ display: 'none' }}>
                              Height:
                              <input
                                type="number"
                                value={uploadedUrls.centerLogoMedia.height}
                                onChange={e =>
                                  setUploadedUrls({
                                    ...uploadedUrls,
                                    centerLogoMedia: {
                                      ...uploadedUrls.centerLogoMedia,
                                      height: Number(e.target.value),
                                    },
                                  })
                                }
                              />
                            </label>
                          </div>
                          <small style={{ color: '#000000' }}>
                            Note: The <code>height</code> will be set to the same aspect ratio as
                            the graphic
                          </small>
                        </div>
                      </div> */}

                      <div className="col-md-6 d-flex p-3">
                        <div
                          className={`form-group menu-card2 ${!uploadedUrls?.centerBelowMenuMedia?.enabled ? 'disabled' : ''} h-100 w-100`}
                          style={{
                            height: 'auto',
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'space-around',
                            gap: '5px',
                          }}
                        >
                          {/* ENABLE TOGGLE */}
                          <div className="form-group">
                            <label>Lower Center Menu Media</label>
                            <ToggleSwitch
                              label="Enable"
                              isOn={uploadedUrls.centerBelowMenuMedia.enabled}
                              id={'centerBelowMenuMedia'}
                              onChange={value =>
                                handleToggleChangeMedia('centerBelowMenuMedia', value)
                              }
                            />
                          </div>

                          {/* DROPZONE + PREVIEW */}
                          <div
                            style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '5px' }}
                          >
                            <MediaDropzone
                              onDrop={createDropHandler(setCenterBelowMenuMedia)}
                              selectedFile={centerBelowMenuMedia}
                            />

                            <UploadedUrlImage url={uploadedUrls.centerBelowMenuMedia} />
                          </div>

                          {/* UPLOADED URL LIST */}
                          <div>
                            <UploadedUrl
                              url={uploadedUrls.centerBelowMenuMedia}
                              buttonColor={buttonColor}
                              deleteFile={() =>
                                deleteFile(
                                  uploadedUrls?.centerBelowMenuMedia?.fileUrl,
                                  'centerBelowMenuMedia'
                                )
                              }
                            />
                          </div>

                          {/* BUTTON + CHECKBOXES + WIDTH */}
                          <div
                            style={{
                              display: 'flex',
                              justifyContent: 'space-between',
                              alignItems: 'center',
                            }}
                          >
                            {/* UPLOAD BUTTON */}
                            <UploadButton
                              uploading={uploadingStates.centerBelowMenuMedia}
                              onUpload={() =>
                                handleUploadContent(centerBelowMenuMedia, 'centerBelowMenuMedia')
                              }
                              buttonColor={buttonColor} style={{ margin: '0' }}
                            />

                            {/* CHECKBOXES */}
                            <div
                              className="dimensions"
                              style={{
                                display: 'flex',
                                flexDirection: 'column',
                                gap: '10px',
                              }}
                            >
                              <div
                                className="setting form-group custom-control custom-checkbox"
                                style={{ marginBottom: '0px', display: 'none' }}
                              >
                                <input
                                  type="checkbox"
                                  checked={uploadedUrls.centerBelowMenuMedia.disabledPadding}
                                  onChange={e =>
                                    setUploadedUrls({
                                      ...uploadedUrls,
                                      centerBelowMenuMedia: {
                                        ...uploadedUrls.centerBelowMenuMedia,
                                        disabledPadding: e.target.checked,
                                      },
                                    })
                                  }
                                  id={`disable_padding_centerBelowMenuMedia`}
                                  className="custom-control-input"
                                />

                                <label
                                  className="custom-control-label"
                                  htmlFor={`disable_padding_centerBelowMenuMedia`}
                                >
                                  Disable Top Margin
                                </label>
                              </div>

                              <div
                                className="setting form-group custom-control custom-checkbox"
                                style={{ marginBottom: '0px', display: 'none' }}
                              >
                                <input
                                  type="checkbox"
                                  checked={uploadedUrls.centerBelowMenuMedia.disabledMargin}
                                  onChange={e =>
                                    setUploadedUrls({
                                      ...uploadedUrls,
                                      centerBelowMenuMedia: {
                                        ...uploadedUrls.centerBelowMenuMedia,
                                        disabledMargin: e.target.checked,
                                      },
                                    })
                                  }
                                  id={`disable_marginLeft_centerBelowMenuMedia`}
                                  className="custom-control-input"
                                />

                                <label
                                  className="custom-control-label"
                                  htmlFor={`disable_marginLeft_centerBelowMenuMedia`}
                                >
                                  Disable Left Margin
                                </label>
                              </div>
                            </div>

                            {/* WIDTH INPUT */}
                            <div
                              style={{
                                // flex: '1',
                                display: 'flex',
                                justifyContent: 'end',
                                alignItems: 'center',
                                height: '100%',
                              }}
                            >
                              <div
                                style={{
                                  width: '60%',
                                  display: 'flex',
                                  alignItems: 'center',
                                  gap: '10px',
                                  height: '100%',
                                }}
                              >
                                <label style={{ fontWeight: '600', whiteSpace: 'nowrap', margin: '0' }}>
                                  Size (%):
                                </label>

                                <input
                                  type="number"
                                  style={{ width: '100%', height: '100%' }}
                                  value={uploadedUrls.centerBelowMenuMedia.width}
                                  onChange={e =>
                                    setUploadedUrls({
                                      ...uploadedUrls,
                                      centerBelowMenuMedia: {
                                        ...uploadedUrls.centerBelowMenuMedia,
                                        width: Number(e.target.value),
                                      },
                                    })
                                  }
                                />
                              </div>

                              <label style={{ display: 'none' }}>
                                Height:
                                <input
                                  type="number"
                                  value={uploadedUrls.centerBelowMenuMedia.height}
                                  onChange={e =>
                                    setUploadedUrls({
                                      ...uploadedUrls,
                                      centerBelowMenuMedia: {
                                        ...uploadedUrls.centerBelowMenuMedia,
                                        height: Number(e.target.value),
                                      },
                                    })
                                  }
                                />
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-md-6 d-flex p-3">
                        <div
                          className={`form-group menu-card2 ${!uploadedUrls?.centerLogoMedia?.enabled ? 'disabled' : ''} h-100 w-100`}
                          style={{
                            height: 'auto',
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'space-around',
                            gap: '5px',
                          }}
                        >
                          {/* ENABLE TOGGLE */}
                          <div className="form-group">
                            <label>Center Logo:</label>
                            <ToggleSwitch
                              label="Enable"
                              isOn={uploadedUrls.centerLogoMedia.enabled}
                              id={'centerLogoMedia'}
                              onChange={value => handleToggleChangeMedia('centerLogoMedia', value)}
                            />
                          </div>

                          {/* DROPZONE + PREVIEW */}
                          <div
                            style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '5px' }}
                          >
                            <MediaDropzone
                              onDrop={createDropHandler(setCenterLogoMedia)}
                              selectedFile={centerLogoMedia}
                            />

                            <UploadedUrlImage url={uploadedUrls.centerLogoMedia} />
                          </div>

                          {/* UPLOADED URL LIST */}
                          <div>
                            <UploadedUrl
                              url={uploadedUrls.centerLogoMedia}
                              buttonColor={buttonColor}
                              deleteFile={() =>
                                deleteFile(
                                  uploadedUrls?.centerLogoMedia?.fileUrl,
                                  'centerLogoMedia'
                                )
                              }
                            />
                          </div>

                          {/* BUTTON + CHECKBOXES + WIDTH */}
                          <div
                            style={{
                              display: 'flex',
                              justifyContent: 'space-between',
                              alignItems: 'center',
                            }}
                          >
                            {/* UPLOAD BUTTON */}
                            <UploadButton
                              uploading={uploadingStates.centerLogoMedia}
                              onUpload={() =>
                                handleUploadContent(centerLogoMedia, 'centerLogoMedia')
                              }
                              buttonColor={buttonColor}
                            />

                            {/* CHECKBOXES */}
                            <div
                              className="dimensions"
                              style={{
                                display: 'flex',
                                flexDirection: 'column',
                                gap: '10px',
                              }}
                            >
                              <div
                                className="setting form-group custom-control custom-checkbox"
                                style={{ marginBottom: '0px', display: 'none' }}
                              >
                                <input
                                  type="checkbox"
                                  checked={uploadedUrls.centerLogoMedia.disabledPadding}
                                  onChange={e =>
                                    setUploadedUrls({
                                      ...uploadedUrls,
                                      centerLogoMedia: {
                                        ...uploadedUrls.centerLogoMedia,
                                        disabledPadding: e.target.checked,
                                      },
                                    })
                                  }
                                  id={`disable_padding_centerLogoMedia`}
                                  className="custom-control-input"
                                />

                                <label
                                  className="custom-control-label"
                                  htmlFor={`disable_padding_centerLogoMedia`}
                                >
                                  Disable Top Margin
                                </label>
                              </div>

                              <div
                                className="setting form-group custom-control custom-checkbox"
                                style={{ marginBottom: '0px', display: 'none' }}
                              >
                                <input
                                  type="checkbox"
                                  checked={uploadedUrls.centerLogoMedia.disabledMargin}
                                  onChange={e =>
                                    setUploadedUrls({
                                      ...uploadedUrls,
                                      centerLogoMedia: {
                                        ...uploadedUrls.centerLogoMedia,
                                        disabledMargin: e.target.checked,
                                      },
                                    })
                                  }
                                  id={`disable_marginLeft_centerLogoMedia`}
                                  className="custom-control-input"
                                />

                                <label
                                  className="custom-control-label"
                                  htmlFor={`disable_marginLeft_centerLogoMedia`}
                                >
                                  Disable Left Margin
                                </label>
                              </div>
                            </div>

                            {/* WIDTH INPUT */}
                            <div
                              style={{
                                // flex: '1',
                                display: 'flex',
                                justifyContent: 'end',
                                alignItems: 'center',
                                height: '100%',
                              }}
                            >
                              <div
                                style={{
                                  width: '60%',
                                  display: 'flex',
                                  alignItems: 'center',
                                  gap: '10px',
                                  height: '100%',
                                }}
                              >
                                <label style={{ fontWeight: '600', whiteSpace: 'nowrap', margin: '0' }}>
                                  Size (%):
                                </label>

                                <input
                                  type="number"
                                  style={{ width: '100%', height: '100%' }}
                                  value={uploadedUrls.centerLogoMedia.width}
                                  onChange={e =>
                                    setUploadedUrls({
                                      ...uploadedUrls,
                                      centerLogoMedia: {
                                        ...uploadedUrls.centerLogoMedia,
                                        width: Number(e.target.value),
                                      },
                                    })
                                  }
                                />
                              </div>

                              <label style={{ display: 'none' }}>
                                Height:
                                <input
                                  type="number"
                                  value={uploadedUrls.centerLogoMedia.height}
                                  onChange={e =>
                                    setUploadedUrls({
                                      ...uploadedUrls,
                                      centerLogoMedia: {
                                        ...uploadedUrls.centerLogoMedia,
                                        height: Number(e.target.value),
                                      },
                                    })
                                  }
                                />
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="row ">
                      {/* <div className="col-md-6 ">
                        <div
                          className={`form-group menu-card2 ${!uploadedUrls?.splashVideo?.enabled ? 'disabled' : ''}`}
                          style={{ height: '330px' }}
                        >
                          <label>Menu Page Video 1:</label>
                          <ToggleSwitch
                            label="Enable"
                            isOn={uploadedUrls.splashVideo.enabled}
                            onChange={val => handleToggleChangeMedia('splashVideo', val)}
                            id={'splashVideo'}
                          />
                          <MediaDropzone
                            onDrop={createDropHandler(setSplashVideoMedia)}
                            selectedFile={splashVideoMedia}
                          />
                          <UploadButton
                            uploading={uploadingStates.splashVideo}
                            onUpload={() => handleUploadContent(splashVideoMedia, 'splashVideo')}
                            buttonColor={buttonColor}
                          />
                          <UploadedUrl
                            url={uploadedUrls.splashVideo}
                            buttonColor={buttonColor}
                            deleteFile={() =>
                              deleteFile(uploadedUrls?.splashVideo?.fileUrl, 'splashVideo')
                            }
                          />
                        </div>
                      </div>

                      <div className="col-md-6 ">
                        <div
                          className={`form-group menu-card2 ${!uploadedUrls?.splashVideotwo?.enabled ? 'disabled' : ''}`}
                        >
                          <label>Menu Page Video 2:</label>
                          <ToggleSwitch
                            label="Enable"
                            isOn={uploadedUrls.splashVideotwo.enabled}
                            onChange={val => handleToggleChangeMedia('splashVideotwo', val)}
                            id={'splashVideotwo'}
                          />
                          <MediaDropzone
                            onDrop={createDropHandler(setSplashVideoMediaTwo)}
                            selectedFile={splashVideoMediaTwo}
                          />
                          <UploadButton
                            uploading={uploadingStates.splashVideotwo}
                            onUpload={() =>
                              handleUploadContent(splashVideoMediaTwo, 'splashVideotwo')
                            }
                            buttonColor={buttonColor}
                          />
                          <UploadedUrl
                            url={uploadedUrls.splashVideotwo}
                            buttonColor={buttonColor}
                            deleteFile={() =>
                              deleteFile(uploadedUrls?.splashVideotwo?.fileUrl, 'splashVideotwo')
                            }
                          />
                        </div>
                      </div> */}

                      <div className="col-md-6 d-flex p-3">
                        <div
                          className={`form-group menu-card2 ${!uploadedUrls?.splashVideo?.enabled ? 'disabled' : ''
                            } w-100 h-100`}
                          style={{
                            height: 'auto',
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'space-around',
                            gap: '5px',
                          }}
                        >
                          {/* ENABLE TOGGLE */}
                          <div className="form-group">
                            <label>Menu Page Video 1:</label>
                            <ToggleSwitch
                              label="Enable"
                              isOn={uploadedUrls.splashVideo.enabled}
                              onChange={val => handleToggleChangeMedia('splashVideo', val)}
                              id={'splashVideo'}
                            />
                          </div>

                          {/* DROPZONE + PREVIEW */}
                          <div
                            style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '5px' }}
                          >
                            <MediaDropzone
                              onDrop={createDropHandler(setSplashVideoMedia)}
                              selectedFile={splashVideoMedia}
                            />

                            <UploadedUrlImage url={uploadedUrls.splashVideo} />
                          </div>

                          {/* UPLOADED URL */}
                          <UploadedUrl
                            url={uploadedUrls.splashVideo}
                            buttonColor={buttonColor}
                            deleteFile={() =>
                              deleteFile(uploadedUrls?.splashVideo?.fileUrl, 'splashVideo')
                            }
                          />

                          {/* UPLOAD BUTTON ONLY */}
                          <div style={{ marginTop: '10px', display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end' }}>
                            <UploadButton
                              uploading={uploadingStates.splashVideo}
                              onUpload={() => handleUploadContent(splashVideoMedia, 'splashVideo')}
                              buttonColor={buttonColor} style={{ margin: '0' }}
                            />




                            <div style={{ marginTop: '10px', display: 'flex', alignItems: 'center', gap: '10px' }}>
                              <button
                                type="button"
                                onClick={() => openCaptionModal('splashVideo')}
                                style={{
                                  backgroundColor: buttonColor,
                                  color: '#ffffffff',
                                  border: '1px solid #ddd',
                                  borderRadius: '4px',
                                  padding: '6px 12px',
                                  cursor: 'pointer',
                                  fontSize: '15px',
                                }}
                              >
                                {uploadedUrls.splashVideo.captionFile ? 'Manage Captions' : 'Upload Captions'}
                              </button>

                              {uploadedUrls.splashVideo.captionFile && (
                                <span style={{ fontSize: '15px', color: '#252725ff', display: 'flex', alignItems: 'center', gap: '4px', fontWeight: '700' }}>
                                  <i className="bi bi-cc-circle"></i>
                                  Captions Available
                                </span>
                              )}

                              {/* Modal for video 1 */}
                              <CaptionUploadModal
                                isOpen={modalStates.splashVideo}
                                onClose={() => closeCaptionModal('splashVideo')}
                                onUpload={(captionFile, convertSrtToVtt) =>
                                  handleCaptionUpload(captionFile, convertSrtToVtt, 'splashVideo')
                                }
                                existingCaptionUrl={uploadedUrls.splashVideo.captionFile}
                                buttonColor={buttonColor}
                                showMsgSuccessToast={showMsgSuccessToast}
                                showErrorToast={showErrorToast}
                              />
                            </div>




                          </div>
                        </div>
                      </div>

                      <div className="col-md-6 d-flex p-3">
                        <div
                          className={`form-group menu-card2 ${!uploadedUrls?.splashVideotwo?.enabled ? 'disabled' : ''
                            } w-100 h-100`}
                          style={{
                            height: 'auto',
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'space-around',
                            gap: '5px',
                          }}
                        >
                          {/* ENABLE TOGGLE */}
                          <div className="form-group">
                            <label>Menu Page Video 2:</label>
                            <ToggleSwitch
                              label="Enable"
                              isOn={uploadedUrls.splashVideotwo.enabled}
                              onChange={val => handleToggleChangeMedia('splashVideotwo', val)}
                              id={'splashVideotwo'}
                            />
                          </div>

                          {/* DROPZONE + PREVIEW */}
                          <div
                            style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '5px' }}
                          >
                            <MediaDropzone
                              onDrop={createDropHandler(setSplashVideoMediaTwo)}
                              selectedFile={splashVideoMediaTwo}
                            />

                            <UploadedUrlImage url={uploadedUrls.splashVideotwo} />
                          </div>

                          {/* UPLOADED URL LIST */}
                          <UploadedUrl
                            url={uploadedUrls.splashVideotwo}
                            buttonColor={buttonColor}
                            deleteFile={() =>
                              deleteFile(uploadedUrls?.splashVideotwo?.fileUrl, 'splashVideotwo')
                            }
                          />

                          {/* UPLOAD BUTTON ONLY */}
                          <div style={{ marginTop: '10px', display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end' }}>
                            <UploadButton
                              uploading={uploadingStates.splashVideotwo}
                              onUpload={() =>
                                handleUploadContent(splashVideoMediaTwo, 'splashVideotwo')
                              }
                              buttonColor={buttonColor}
                            />

                            <div style={{ marginTop: '10px', display: 'flex', alignItems: 'center', gap: '10px' }}>
                              <button
                                type="button"
                                onClick={() => openCaptionModal('splashVideotwo')}
                                style={{
                                  backgroundColor: buttonColor,
                                  color: '#ffffffff',
                                  border: '1px solid #ddd',
                                  borderRadius: '4px',
                                  padding: '6px 12px',
                                  cursor: 'pointer',
                                  fontSize: '15px',
                                }}
                              >
                                {uploadedUrls.splashVideotwo.captionFile ? 'Manage Captions' : 'Upload Captions'}
                              </button>

                              {uploadedUrls.splashVideotwo.captionFile && (
                                <span style={{ fontSize: '15px', color: '#252725ff', display: 'flex', alignItems: 'center', gap: '4px', fontWeight: '700' }}>
                                  <i className="bi bi-cc-circle"></i>
                                  Captions Available
                                </span>
                              )}

                              {/* Modal for video 2 */}
                              <CaptionUploadModal
                                isOpen={modalStates.splashVideotwo}
                                onClose={() => closeCaptionModal('splashVideotwo')}
                                onUpload={(captionFile, convertSrtToVtt) =>
                                  handleCaptionUpload(captionFile, convertSrtToVtt, 'splashVideotwo')
                                }
                                existingCaptionUrl={uploadedUrls.splashVideotwo.captionFile}
                                buttonColor={buttonColor}
                                showMsgSuccessToast={showMsgSuccessToast}
                                showErrorToast={showErrorToast}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      {/* <div className="col-md-6 ">
                        <div
                          className={`form-group menu-card2 ${!uploadedUrls?.splashVideothree?.enabled ? 'disabled' : ''}`}
                        >
                          <label>Menu Page Video 3:</label>
                          <ToggleSwitch
                            label="Enable"
                            isOn={uploadedUrls.splashVideothree.enabled}
                            onChange={val => handleToggleChangeMedia('splashVideothree', val)}
                            id={'splashVideothree'}
                          />
                          <MediaDropzone
                            onDrop={createDropHandler(setSplashVideoMediaThree)}
                            selectedFile={splashVideoMediaThree}
                          />
                          <UploadButton
                            uploading={uploadingStates.splashVideothree}
                            onUpload={() =>
                              handleUploadContent(splashVideoMediaThree, 'splashVideothree')
                            }
                            buttonColor={buttonColor}
                          />
                          <UploadedUrl
                            url={uploadedUrls.splashVideothree}
                            buttonColor={buttonColor}
                            deleteFile={() =>
                              deleteFile(
                                uploadedUrls?.splashVideothree?.fileUrl,
                                'splashVideothree'
                              )
                            }
                          />
                        </div>
                      </div>

                      <div className="col-md-6 ">
                        <div
                          className={`form-group menu-card2 ${!uploadedUrls?.backMenuMedia?.enabled ? 'disabled' : ''}`}
                        >
                          <label>Back Menu Media:</label>
                          <ToggleSwitch
                            label="Enable"
                            isOn={uploadedUrls.backMenuMedia.enabled}
                            onChange={val => handleToggleChangeMedia('backMenuMedia', val)}
                            id={'backMenuMedia'}
                          />
                          <MediaDropzone
                            onDrop={createDropHandler(setBackMenuMedia)}
                            selectedFile={backMenuMedia}
                          />
                          <UploadButton
                            uploading={uploadingStates.backMenuMedia}
                            onUpload={() => handleUploadContent(backMenuMedia, 'backMenuMedia')}
                            buttonColor={buttonColor}
                          />
                          <UploadedUrl
                            url={uploadedUrls.backMenuMedia}
                            buttonColor={buttonColor}
                            deleteFile={() =>
                              deleteFile(uploadedUrls?.backMenuMedia?.fileUrl, 'backMenuMedia')
                            }
                          />
                        </div>
                      </div> */}

                      <div className="col-md-6 d-flex p-3">
                        <div
                          className={`form-group menu-card2 ${!uploadedUrls?.splashVideothree?.enabled ? 'disabled' : ''
                            } h-100 w-100`}
                          style={{
                            height: 'auto',
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'space-around',
                            gap: '5px',
                          }}
                        >
                          {/* ENABLE TOGGLE */}
                          <div className="form-group">
                            <label>Menu Page Video 3:</label>
                            <ToggleSwitch
                              label="Enable"
                              isOn={uploadedUrls.splashVideothree.enabled}
                              onChange={val => handleToggleChangeMedia('splashVideothree', val)}
                              id={'splashVideothree'}
                            />
                          </div>

                          {/* DROPZONE + PREVIEW */}
                          <div
                            style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '5px' }}
                          >
                            <MediaDropzone
                              onDrop={createDropHandler(setSplashVideoMediaThree)}
                              selectedFile={splashVideoMediaThree}
                            />

                            <UploadedUrlImage url={uploadedUrls.splashVideothree} />
                          </div>

                          {/* UPLOADED URL LIST */}
                          <UploadedUrl
                            url={uploadedUrls.splashVideothree}
                            buttonColor={buttonColor}
                            deleteFile={() =>
                              deleteFile(
                                uploadedUrls?.splashVideothree?.fileUrl,
                                'splashVideothree'
                              )
                            }
                          />

                          {/* UPLOAD BUTTON */}
                          <div style={{ marginTop: '10px', display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end' }}>
                            <UploadButton
                              uploading={uploadingStates.splashVideothree}
                              onUpload={() =>
                                handleUploadContent(splashVideoMediaThree, 'splashVideothree')
                              }
                              buttonColor={buttonColor}
                            />

                            <div style={{ marginTop: '10px', display: 'flex', alignItems: 'center', gap: '10px' }}>
                              <button
                                type="button"
                                onClick={() => openCaptionModal('splashVideothree')}
                                style={{
                                  backgroundColor: buttonColor,
                                  color: '#ffffffff',
                                  border: '1px solid #ddd',
                                  borderRadius: '4px',
                                  padding: '6px 12px',
                                  cursor: 'pointer',
                                  fontSize: '15px',
                                }}
                              >
                                {uploadedUrls.splashVideothree.captionFile ? 'Manage Captions' : 'Upload Captions'}
                              </button>

                              {uploadedUrls.splashVideothree.captionFile && (
                                <span style={{ fontSize: '15px', color: '#252725ff', display: 'flex', alignItems: 'center', gap: '4px', fontWeight: '700' }}>
                                  <i className="bi bi-cc-circle"></i>
                                  Captions Available
                                </span>
                              )}

                              {/* Modal for video 3 */}
                              <CaptionUploadModal
                                isOpen={modalStates.splashVideothree}
                                onClose={() => closeCaptionModal('splashVideothree')}
                                onUpload={(captionFile, convertSrtToVtt) =>
                                  handleCaptionUpload(captionFile, convertSrtToVtt, 'splashVideothree')
                                }
                                existingCaptionUrl={uploadedUrls.splashVideothree.captionFile}
                                buttonColor={buttonColor}
                                showMsgSuccessToast={showMsgSuccessToast}
                                showErrorToast={showErrorToast}
                              />
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-md-6 d-flex p-3">
                        <div
                          className={`form-group menu-card2 ${!uploadedUrls?.backMenuMedia?.enabled ? 'disabled' : ''
                            } h-100 w-100`}
                          style={{
                            height: 'auto',
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'space-around',
                            gap: '5px',
                          }}
                        >
                          {/* ENABLE TOGGLE */}
                          <div className="form-group">
                            <label>Back Menu Media:</label>
                            <ToggleSwitch
                              label="Enable"
                              isOn={uploadedUrls.backMenuMedia.enabled}
                              onChange={val => handleToggleChangeMedia('backMenuMedia', val)}
                              id={'backMenuMedia'}
                            />
                          </div>

                          {/* DROPZONE + PREVIEW */}
                          <div
                            style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '5px' }}
                          >
                            <MediaDropzone
                              onDrop={createDropHandler(setBackMenuMedia)}
                              selectedFile={backMenuMedia}
                            />

                            <UploadedUrlImage url={uploadedUrls.backMenuMedia} />
                          </div>

                          {/* UPLOADED URL LIST */}
                          <UploadedUrl
                            url={uploadedUrls.backMenuMedia}
                            buttonColor={buttonColor}
                            deleteFile={() =>
                              deleteFile(uploadedUrls?.backMenuMedia?.fileUrl, 'backMenuMedia')
                            }
                          />

                          {/* UPLOAD BUTTON */}
                          <div
                            style={{
                              display: 'flex',
                              justifyContent: 'space-between',
                              alignItems: 'center',
                            }}
                          >
                            <UploadButton
                              uploading={uploadingStates.backMenuMedia}
                              onUpload={() => handleUploadContent(backMenuMedia, 'backMenuMedia')}
                              buttonColor={buttonColor}
                            />
                            <div
                              style={{
                                // flex: '1',
                                display: 'flex',
                                justifyContent: 'end',
                                alignItems: 'center',
                                height: '100%',
                              }}
                            >
                              <div
                                style={{
                                  width: '60%',
                                  display: 'flex',
                                  alignItems: 'center',
                                  gap: '10px',
                                  height: '100%',
                                }}
                              >
                                <label style={{ fontWeight: '600', whiteSpace: 'nowrap', margin: '0' }}>
                                  Size (%):
                                </label>

                                <input
                                  style={{ width: '100%', height: '100%' }}
                                  type="number"
                                  value={uploadedUrls.backMenuMedia.width}
                                  onChange={e =>
                                    setUploadedUrls({
                                      ...uploadedUrls,
                                      backMenuMedia: {
                                        ...uploadedUrls.backMenuMedia,
                                        width: Number(e.target.value),
                                      },
                                    })
                                  }
                                />
                              </div>

                              <label style={{ display: 'none' }}>
                                Height:
                                <input
                                  type="number"
                                  value={uploadedUrls.backMenuMedia.height}
                                  onChange={e =>
                                    setUploadedUrls({
                                      ...uploadedUrls,
                                      backMenuMedia: {
                                        ...uploadedUrls.backMenuMedia,
                                        height: Number(e.target.value),
                                      },
                                    })
                                  }
                                />
                              </label>
                            </div>

                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-group menu-card2">
                          <label>How Many Time Video repeat (0 for forever):</label>
                          <input
                            type="number"
                            value={videotime}
                            onChange={e => setVideoTime(Number(e.target.value))}
                            placeholder="Enter Video Time"
                            className="form-control"
                          />
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="form-group menu-card2 ">
                          <label>External Web Link</label>
                          <input
                            type="text"
                            value={externalweblink}
                            onChange={e => setExternalweblink(e.target.value)}
                            placeholder="Enter External Web Link"
                            className="form-control"
                          />
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-6">
                        <button
                          style={{ backgroundColor: buttonColor }}
                          type="submit"
                          onClick={handleSubmitPage}
                        >
                          Submit
                        </button>
                      </div>
                    </div>
                  </>
                )}

                {value === 2 && (
                  <div style={{ padding: '20px', textAlign: 'center' }}>
                    {/* Title */}
                    <h2>Pick a Color & Shape for Your QR Code</h2>

                    {/* Patterns Grid */}
                    <div
                      style={{
                        display: 'flex',
                        gap: '20px',
                        justifyContent: 'center',
                        flexWrap: 'wrap',
                        marginTop: '20px',
                        marginBottom: '20px',
                      }}
                    >
                      {patterns.map(pattern => (
                        <div key={pattern.id} style={{ textAlign: 'center' }}>
                          {/* Pattern Image */}
                          <div
                            onClick={() => handleSelectPattern(pattern.id)}
                            style={{
                              border: `3px solid ${selectedPattern === pattern.id ? '#4caf50' : 'transparent'
                                }`,
                              borderRadius: '8px',
                              cursor: 'pointer',
                              transition: 'border-color 0.3s',
                              padding: '5px',
                              boxShadow:
                                selectedPattern === pattern.id
                                  ? '0 4px 6px rgba(0, 0, 0, 0.1)'
                                  : 'none',
                            }}
                          >
                            <img
                              src={pattern.src}
                              alt={pattern.alt}
                              style={{
                                width: '70px',

                                objectFit: 'cover',
                                borderRadius: '5px',
                              }}
                            />
                            <p style={{ textTransform: 'capitalize', marginTop: '5px' }}>
                              {pattern.alt}
                            </p>
                          </div>
                        </div>
                      ))}
                    </div>

                    {/* Selected options */}

                    {selectedOption?.type === 'frame' && (
                      <div className="menu-card2">
                        <div
                          style={{
                            display: 'flex',
                            gap: '55px',
                            justifyContent: 'center',
                            flexWrap: 'wrap',
                            marginTop: '20px',
                            padding: '11px',
                            // marginBottom:"20px"
                          }}
                        >
                          {(selectedOption.options || []).map((pattern, index) => (
                            <div key={index} style={{ textAlign: 'center' }}>
                              {/* Pattern Image */}
                              <div
                                style={{
                                  border: `3px solid ${qrSettings?.frame.frameStyle === pattern.value
                                    ? '#4caf50'
                                    : 'transparent'
                                    }`,
                                  borderRadius: '8px',
                                  cursor: 'pointer',
                                  transition: 'border-color 0.3s',
                                  padding: '5px',
                                  //boxShadow: selectedPattern === pattern.id ? '0 4px 6px rgba(0, 0, 0, 0.1)' : 'none',
                                }}
                                className="row"
                              >
                                {pattern.value === 'none' && (
                                  <p
                                    style={{
                                      width: '100px',
                                      height: '100px',
                                      borderRadius: '5px',
                                      padding: '28px',
                                    }}
                                    onClick={e =>
                                      handleChangeQR('frame', 'frameStyle', pattern.value)
                                    }
                                  >
                                    {pattern.value}
                                  </p>
                                )}
                                {pattern.value !== 'none' && (
                                  <img
                                    src={pattern.src}
                                    alt={pattern.value}
                                    style={{
                                      width: '100px',
                                      objectFit: 'cover',
                                      borderRadius: '5px',
                                    }}
                                    onClick={e =>
                                      handleChangeQR('frame', 'frameStyle', pattern.value)
                                    }
                                  />
                                )}
                              </div>
                            </div>
                          ))}
                        </div>

                        <div className="row" style={{ marginTop: '20px' }}>
                          <div className="form-group col-md-4" style={{}}>
                            <label>Select Frame Color:</label>
                            <div className="input-button-group">
                              <MuiColorInput
                                className="form-control"
                                format="hex"
                                value={qrSettings.frame.frameColor}
                                onChange={newHex =>
                                  handleChangeQR('frame', 'frameColor', newHex?.toUpperCase?.())
                                }
                                // size="small"
                                isAlphaHidden={true} // This disables the alpha slider
                                sx={{
                                  '& .MuiOutlinedInput-root': {
                                    borderRadius: '0px !important',
                                    height: 53,
                                  },
                                  '& .MuiOutlinedInput-input': {
                                    height: '36px',
                                  },
                                  '& .MuiColorInput-Button': {
                                    width: '49px !important', // Increase width
                                    height: '40px !important',
                                  },
                                  '& .MuiInputAdornment-root .MuiBox-root': {
                                    width: 18,
                                    height: 18,
                                  },
                                }}
                              />
                              {/* <input
                                type="color"
                                placeholder="Enter text"
                                className="form-control"
                                value={qrSettings.frame.frameColor}
                                onChange={(e) => handleChangeQR("frame", "frameColor", e.target.value)}
                              /> */}
                            </div>
                          </div>

                          <div className="form-group col-md-4" style={{}}>
                            <label>Select Frame Text Color:</label>
                            <div className="input-button-group">
                              <input
                                type="color"
                                placeholder="Enter text"
                                className="form-control"
                              // value={qrSettings.frame.}
                              // onChange={(e) => handleChangeQR("frame", "frameColor", e.target.value)}
                              />
                            </div>
                          </div>

                          <div className="form-group col-md-4" style={{}}>
                            <label>Enter Frame Text:</label>
                            <div className="input-button-group">
                              <input
                                type="text"
                                placeholder="Enter text"
                                className="form-control"
                                value={qrSettings.frame.frameText}
                                onChange={e => handleChangeQR('frame', 'frameText', e.target.value)}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    )}

                    {/* Eyes */}

                    {selectedOption?.type === 'eyes' && (
                      <div className="menu-card2">
                        <div
                          style={{
                            display: 'flex',
                            gap: '55px',
                            justifyContent: 'center',
                            flexWrap: 'wrap',
                            marginTop: '20px',
                            padding: '11px',
                            // marginBottom:"20px"
                          }}
                        >
                          {(selectedOption.options || []).map((pattern, index) => (
                            <div key={index} style={{ textAlign: 'center' }}>
                              {/* Pattern Image */}
                              <div
                                style={{
                                  border: `3px solid ${qrSettings?.eyes.eyeFrameShape === pattern.value
                                    ? '#4caf50'
                                    : 'transparent'
                                    }`,
                                  borderRadius: '8px',
                                  cursor: 'pointer',
                                  transition: 'border-color 0.3s',
                                  padding: '5px',
                                  //boxShadow: selectedPattern === pattern.id ? '0 4px 6px rgba(0, 0, 0, 0.1)' : 'none',
                                }}
                                className="row"
                              >
                                <img
                                  src={pattern.src}
                                  alt={''}
                                  style={{
                                    width: '100px',
                                    // height: '100px',
                                    objectFit: 'cover',
                                    borderRadius: '5px',
                                  }}
                                  onClick={e =>
                                    handleChangeQR('eyes', 'eyeFrameShape', pattern.value)
                                  }
                                />
                              </div>
                            </div>
                          ))}
                        </div>

                        <div className="row" style={{ marginTop: '20px' }}>
                          <div className="form-group col-md-6" style={{}}>
                            <label>Select Eye Ball Color:</label>
                            <div className="input-button-group">
                              <MuiColorInput
                                className="form-control"
                                format="hex"
                                value={qrSettings.eyes.eyeBallColor}
                                onChange={newHex =>
                                  handleChangeQR('eyes', 'eyeBallColor', newHex?.toUpperCase?.())
                                }
                                // size="small"
                                isAlphaHidden={true} // This disables the alpha slider
                                sx={{
                                  '& .MuiOutlinedInput-root': {
                                    borderRadius: '0px !important',
                                    height: 53,
                                  },
                                  '& .MuiOutlinedInput-input': {
                                    height: '36px',
                                  },
                                  '& .MuiColorInput-Button': {
                                    width: '49px !important', // Increase width
                                    height: '40px !important',
                                  },
                                  '& .MuiInputAdornment-root .MuiBox-root': {
                                    width: 18,
                                    height: 18,
                                  },
                                }}
                              />
                              {/* <input
                                type="color"
                                placeholder="Enter text"
                                className="form-control"
                                value={qrSettings.eyes.eyeBallColor}
                                onChange={(e) => handleChangeQR("eyes", "eyeBallColor", e.target.value)}
                              /> */}
                            </div>
                          </div>

                          <div className="form-group col-md-6" style={{}}>
                            <label>Select Eye Frame Color:</label>
                            <div className="input-button-group">
                              <MuiColorInput
                                className="form-control"
                                format="hex"
                                value={qrSettings.eyes.eyeFrameColor}
                                onChange={newHex =>
                                  handleChangeQR('eyes', 'eyeFrameColor', newHex?.toUpperCase?.())
                                }
                                // size="small"
                                isAlphaHidden={true} // This disables the alpha slider
                                sx={{
                                  '& .MuiOutlinedInput-root': {
                                    borderRadius: '0px !important',
                                    height: 53,
                                  },
                                  '& .MuiOutlinedInput-input': {
                                    height: '36px',
                                  },
                                  '& .MuiColorInput-Button': {
                                    width: '49px !important', // Increase width
                                    height: '40px !important',
                                  },
                                  '& .MuiInputAdornment-root .MuiBox-root': {
                                    width: 18,
                                    height: 18,
                                  },
                                }}
                              />
                              {/* <input
                                type="color"
                                placeholder="Enter text"
                                className="form-control"
                                value={qrSettings.eyes.eyeFrameColor}
                                onChange={(e) => handleChangeQR("eyes", "eyeFrameColor", e.target.value)}
                              /> */}
                            </div>
                          </div>
                        </div>

                        <div
                          style={{
                            display: 'flex',
                            gap: '55px',
                            justifyContent: 'center',
                            flexWrap: 'wrap',
                            marginTop: '20px',
                            padding: '11px',
                            // marginBottom:"20px"
                          }}
                        >
                          {(selectedOption.eyeFrame || []).map((pattern, index) => (
                            <div key={index} style={{ textAlign: 'center' }}>
                              {/* Pattern Image */}
                              <div
                                style={{
                                  border: `3px solid ${qrSettings?.eyes.eyeBallShape === pattern.value
                                    ? '#4caf50'
                                    : 'transparent'
                                    }`,
                                  borderRadius: '8px',
                                  cursor: 'pointer',
                                  transition: 'border-color 0.3s',
                                  padding: '5px',
                                  //boxShadow: selectedPattern === pattern.id ? '0 4px 6px rgba(0, 0, 0, 0.1)' : 'none',
                                }}
                                className="row"
                              >
                                <img
                                  src={pattern.src}
                                  alt={''}
                                  style={{
                                    width: '50px',
                                    // height: '100px',
                                    objectFit: 'cover',
                                    borderRadius: '5px',
                                  }}
                                  onClick={e =>
                                    handleChangeQR('eyes', 'eyeBallShape', pattern.value)
                                  }
                                />
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    )}

                    {/* Pattern */}

                    {selectedOption?.type === 'pattern' && (
                      <div className="menu-card2">
                        <div
                          style={{
                            display: 'flex',
                            gap: '55px',
                            justifyContent: 'center',
                            flexWrap: 'wrap',
                            marginTop: '20px',
                            padding: '11px',
                            // marginBottom:"20px"
                          }}
                        >
                          {(selectedOption.options || []).map((pattern, index) => (
                            <div key={index} style={{ textAlign: 'center' }}>
                              {/* Pattern Image */}
                              <div
                                style={{
                                  border: `3px solid ${qrSettings?.patterns.dataPattern === pattern.value
                                    ? '#4caf50'
                                    : 'transparent'
                                    }`,
                                  borderRadius: '8px',
                                  cursor: 'pointer',
                                  transition: 'border-color 0.3s',
                                  padding: '5px',
                                  //boxShadow: selectedPattern === pattern.id ? '0 4px 6px rgba(0, 0, 0, 0.1)' : 'none',
                                }}
                                className="row"
                              >
                                <img
                                  src={pattern.src}
                                  alt={''}
                                  style={{
                                    width: '100px',
                                    // height: '100px',
                                    objectFit: 'cover',
                                    borderRadius: '5px',
                                  }}
                                  onClick={e =>
                                    handleChangeQR('patterns', 'dataPattern', pattern.value)
                                  }
                                />
                              </div>
                            </div>
                          ))}
                        </div>

                        <div className="row" style={{ marginTop: '20px' }}>
                          <div className="form-group col-md-12" style={{}}>
                            <label>Select Pattern Color:</label>
                            <div className="input-button-group">
                              <MuiColorInput
                                className="form-control"
                                format="hex"
                                value={qrSettings.patterns.colorDark}
                                onChange={newHex =>
                                  handleChangeQR('patterns', 'colorDark', newHex?.toUpperCase?.())
                                }
                                // size="small"
                                isAlphaHidden={true} // This disables the alpha slider
                                sx={{
                                  '& .MuiOutlinedInput-root': {
                                    borderRadius: '0px !important',
                                    height: 53,
                                  },
                                  '& .MuiOutlinedInput-input': {
                                    height: '36px',
                                  },
                                  '& .MuiColorInput-Button': {
                                    width: '49px !important', // Increase width
                                    height: '40px !important',
                                  },
                                  '& .MuiInputAdornment-root .MuiBox-root': {
                                    width: 18,
                                    height: 18,
                                  },
                                }}
                              />
                              {/* <input
                                type="color"
                                placeholder="Enter text"
                                className="form-control"
                                value={qrSettings.patterns.colorDark}
                                onChange={(e) => handleChangeQR("patterns", "colorDark", e.target.value)}
                              /> */}
                            </div>
                          </div>
                        </div>
                      </div>
                    )}

                    {selectedOption?.type === 'logo' && (
                      <div className="row  menu-card2">
                        <div className="form-group col-md-6" style={{}}>
                          <label className="d-flex align-items-center" style={{ height: '25px' }}>
                            Select Background Color: (Transparent
                            <input
                              type="checkbox"
                              className="ml-1 mr-1"
                              checked={qrSettings.background.backgroundColor === 'transparent'}
                              onChange={e =>
                                handleChangeQR(
                                  'background',
                                  'backgroundColor',
                                  e.target.checked ? 'transparent' : '#000000'
                                )
                              }
                            />
                            )
                          </label>
                          <div className="input-button-group ">
                            <MuiColorInput
                              className="form-control"
                              format="hex"
                              value={qrSettings.background.backgroundColor}
                              onChange={newHex =>
                                handleChangeQR(
                                  'background',
                                  'backgroundColor',
                                  newHex?.toUpperCase?.()
                                )
                              }
                              disabled={qrSettings.background.backgroundColor === 'transparent'} // Disable when transparent
                              // size="small"
                              isAlphaHidden={true} // This disables the alpha slider
                              sx={{
                                '& .MuiOutlinedInput-root': {
                                  borderRadius: '0px !important',
                                  height: 53,
                                },
                                '& .MuiOutlinedInput-input': {
                                  height: '36px',
                                },
                                '& .MuiColorInput-Button': {
                                  width: '49px !important', // Increase width
                                  height: '40px !important',
                                },
                                '& .MuiInputAdornment-root .MuiBox-root': {
                                  width: 18,
                                  height: 18,
                                },
                              }}
                            />
                            {/* <input
                              type="color"
                              disabled={qrSettings.background.backgroundColor === "transparent"} // Disable when transparent

                              placeholder="Enter text"
                              className="form-control"
                              value={qrSettings.background.backgroundColor}
                              onChange={(e) => handleChangeQR("background", "backgroundColor", e.target.value)}
                            /> */}
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="form-group">
                            <label>Enter Page Link:</label>
                            <div className="input-button-group">
                              <input
                                type="text"
                                placeholder="Enter QR Url"
                                value={qrText}
                                onChange={e => setQrText(e.target.value)}
                                className="form-control"
                              />
                            </div>
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className={`form-group `} style={{ height: '330px' }}>
                            <label>Upload Qr Logo:</label>

                            <MediaDropzone
                              onDrop={createDropHandler(setQrLogo)}
                              selectedFile={qrLogo}
                            />
                            <UploadButton
                              uploading={qrUploadingStates.logoImage}
                              onUpload={() => handleUploadContentQrLog(qrLogo)}
                              buttonColor={buttonColor}
                            />
                            <UploadedUrlQr url={qrSettings?.logoImage} />
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="form-group">
                            <label>Select Position Of QR:</label>
                            <div className="input-button-group">
                              <select class="form-control" onChange={handleChangeCorner}>
                                <option value={''}>Select Media Position</option>
                                <option value={'leftTop'}>Left Top</option>
                                <option value={'leftBottom'}>Left Bottom</option>
                                <option value={'rightTop'}>Right Top</option>
                                <option value={'rightBottom'}>Right Bottom</option>
                              </select>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}

                    <div className="row ">
                      <div className="col-md-12 ">
                        <button
                          type="button"
                          onClick={() => generateQRCode()}
                          style={{
                            backgroundColor: buttonColor,
                          }}
                        >
                          {qrLoad ? 'Please Wait...' : 'Generate Qr Code'}
                        </button>
                      </div>
                    </div>
                  </div>
                )}
              </form>

              {value === 3 && (
                <>
                  <div className="row" style={{ marginBottom: '40px', marginTop: '30px' }}>
                    <div className="col-md-12">
                      <div className="col-md-8" style={{ float: 'left' }}>
                        <SplashText
                          text={splashText || 'Splash Text'}
                          settings={primaryMenuTextsettings?.globalSettings}
                        />
                      </div>

                      <div className="col-md-4" style={{ float: 'right' }}>
                        <div className="form-group">
                          {/* <ToggleSwitch
                    
                    label="Customize Global Settings"
                    isOn={primaryMenuTextsettings.enabled}
                    onChange={handleToggleChange}
                    id="menusettings"
                    
                    />                */}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="global-section">
                    {/* Global Settings */}

                    <form
                      className="tab-wizard wizard-circle wizard vertical"
                      onSubmit={handleSubmitPage}
                    >
                      <div className="row menu-card2">
                        <div className="col-md-4">
                          <div className="form-group">
                            <label>Height:</label>
                            <input
                              type="number"
                              value={primaryMenuTextsettings?.globalSettings?.height ?? 0}
                              onChange={e =>
                                handleChangePrimaryText('height', Number(e.target.value))
                              }
                              className="form-control"
                            />
                          </div>
                        </div>

                        <div className="col-md-4">
                          <div className="form-group">
                            <label>Width:</label>
                            <input
                              type="number"
                              value={primaryMenuTextsettings?.globalSettings?.width ?? 0}
                              onChange={e =>
                                handleChangePrimaryText('width', Number(e.target.value))
                              }
                              className="form-control"
                            />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label>Text Alignment (left centre or right):</label>

                            <select
                              id="textAlign"
                              value={primaryMenuTextsettings?.globalSettings?.textAlign || 'left'}
                              onChange={e => handleChangePrimaryText('textAlign', e.target.value)}
                              className="form-select form-control"
                            >
                              <option value="left">Left</option>
                              <option value="center">Center</option>
                              <option value="right">Right</option>
                            </select>
                          </div>
                        </div>
                      </div>

                      {/* Fill Color */}
                      <div className="row menu-card2">
                        <div className="col-md-4">
                          <div className="form-group">
                            <label>Font Family:</label>

                            <select
                              id="font"
                              value={primaryMenuTextsettings?.globalSettings?.font || 'Arial'}
                              onChange={e => handleChangePrimaryText('font', e.target.value)}
                              className="form-select form-control"
                            >
                              {fontOptions}
                            </select>
                          </div>
                        </div>

                        <div className="col-md-4">
                          <div className="form-group">
                            <label className="d-flex align-items-center" style={{ height: '25px' }}>
                              Font color: (Transparent
                              <input
                                type="checkbox"
                                className="ml-1 mr-1"
                                checked={
                                  primaryMenuTextsettings?.globalSettings?.fontColor ===
                                  'transparent'
                                }
                                onChange={e =>
                                  handleChangePrimaryText(
                                    'fontColor',
                                    e.target.checked ? 'transparent' : '#000000'
                                  )
                                }
                              />
                              )
                            </label>

                            <MuiColorInput
                              className="form-control"
                              format="hex"
                              value={
                                primaryMenuTextsettings?.globalSettings?.fontColor || '#000000'
                              }
                              onChange={newHex =>
                                handleChangePrimaryText('fontColor', newHex?.toUpperCase?.())
                              }
                              disabled={
                                primaryMenuTextsettings?.globalSettings?.fontColor === 'transparent'
                              } //
                              // size="small"
                              isAlphaHidden={true} // This disables the alpha slider
                              sx={{
                                '& .MuiOutlinedInput-root': {
                                  borderRadius: '0px !important',
                                  height: 53,
                                },
                                '& .MuiOutlinedInput-input': {
                                  height: '36px',
                                },
                                '& .MuiColorInput-Button': {
                                  width: '49px !important', // Increase width
                                  height: '40px !important',
                                },
                                '& .MuiInputAdornment-root .MuiBox-root': {
                                  width: 18,
                                  height: 18,
                                },
                              }}
                            />

                            {/* <input
                              type="color"
                              disabled={primaryMenuTextsettings?.globalSettings?.fontColor === "transparent"} //
                              value={
                                primaryMenuTextsettings?.globalSettings?.fontColor || "#000000"
                              }
                              onChange={(e) => handleChangePrimaryText('fontColor', e.target.value)}
                              className="form-control"
                            /> */}
                          </div>
                        </div>

                        <div className="col-md-4">
                          <div className="form-group">
                            <label>Font Size:</label>
                            <input
                              type="number"
                              value={primaryMenuTextsettings?.globalSettings?.fontSize || ''}
                              onChange={e =>
                                handleChangePrimaryText('fontSize', Number(e.target.value))
                              }
                              className="form-control"
                            />
                          </div>
                        </div>
                      </div>

                      {/* Shadow Settings */}

                      <div className="row menu-card2">
                        <div className="col-md-3">
                          <div className="form-group">
                            <label>Shadow angle:</label>
                            <input
                              type="number"
                              className="form-control"
                              value={primaryMenuTextsettings?.globalSettings?.shadow?.angle ?? 0}
                              onChange={e =>
                                handleChangePrimaryText('shadow.angle', Number(e.target.value))
                              }
                            />
                          </div>
                        </div>

                        <div className="col-md-3">
                          <div className="form-group">
                            <label>Shadow size:</label>
                            <input
                              type="number"
                              value={primaryMenuTextsettings?.globalSettings?.shadow?.size ?? 0}
                              onChange={e =>
                                handleChangePrimaryText('shadow.size', Number(e.target.value))
                              }
                              className="form-control"
                            />
                          </div>
                        </div>

                        <div className="col-md-3">
                          <div className="form-group">
                            <label>Shadow distance:</label>
                            <input
                              type="number"
                              value={primaryMenuTextsettings?.globalSettings?.shadow?.distance ?? 0}
                              onChange={e =>
                                handleChangePrimaryText('shadow.distance', Number(e.target.value))
                              }
                              className="form-control"
                            />
                          </div>
                        </div>

                        <div className="col-md-3">
                          <div className="form-group">
                            <label>Shadow Alpha:</label>
                            <input
                              type="number"
                              value={primaryMenuTextsettings?.globalSettings?.shadow?.alpha ?? 0}
                              onChange={e =>
                                handleChangePrimaryText('shadow.alpha', Number(e.target.value))
                              }
                              className="form-control"
                            />
                          </div>
                        </div>
                      </div>

                      <div className="row menu-card2">
                        <div className="col-md-6">
                          <div className="form-group">
                            <label className="d-flex align-items-center" style={{ height: '25px' }}>
                              Highlight Font color: (Transparent
                              <input
                                type="checkbox"
                                className="ml-1 mr-1"
                                checked={
                                  primaryMenuTextsettings?.globalSettings?.highlight?.fontColor ===
                                  'transparent'
                                }
                                onChange={e =>
                                  handleChangePrimaryText(
                                    'highlight.fontColor',
                                    e.target.checked ? 'transparent' : '#000000'
                                  )
                                }
                              />
                              )
                            </label>

                            <MuiColorInput
                              className="form-control"
                              format="hex"
                              value={
                                primaryMenuTextsettings?.globalSettings?.highlight?.fontColor ||
                                '#000000'
                              }
                              onChange={newHex =>
                                handleChangePrimaryText(
                                  'highlight.fontColor',
                                  newHex?.toUpperCase?.()
                                )
                              }
                              disabled={
                                primaryMenuTextsettings?.globalSettings?.highlight?.fontColor ===
                                'transparent'
                              }
                              // size="small"
                              isAlphaHidden={true} // This disables the alpha slider
                              sx={{
                                '& .MuiOutlinedInput-root': {
                                  borderRadius: '0px !important',
                                  height: 53,
                                },
                                '& .MuiOutlinedInput-input': {
                                  height: '36px',
                                },
                                '& .MuiColorInput-Button': {
                                  width: '49px !important', // Increase width
                                  height: '40px !important',
                                },
                                '& .MuiInputAdornment-root .MuiBox-root': {
                                  width: 18,
                                  height: 18,
                                },
                              }}
                            />

                            {/* <input
                              type="color"
                              className="form-control"
                              disabled={primaryMenuTextsettings?.globalSettings?.highlight?.fontColor === "transparent"}
                              value={
                                primaryMenuTextsettings?.globalSettings?.highlight?.fontColor || "#000000"
                              }
                              onChange={(e) => handleChangePrimaryText('highlight.fontColor', e.target.value)}
                            /> */}
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="form-group">
                            <label className="d-flex align-items-center" style={{ height: '25px' }}>
                              Shadow color: (Transparent
                              <input
                                type="checkbox"
                                className="ml-1 mr-1"
                                checked={
                                  primaryMenuTextsettings?.globalSettings?.shadow?.color ===
                                  'transparent'
                                }
                                onChange={e =>
                                  handleChangePrimaryText(
                                    'shadow.color',
                                    e.target.checked ? 'transparent' : '#000000'
                                  )
                                }
                              />
                              )
                            </label>

                            <MuiColorInput
                              className="form-control"
                              format="hex"
                              value={
                                primaryMenuTextsettings?.globalSettings?.shadow?.color || '#000000'
                              }
                              onChange={newHex =>
                                handleChangePrimaryText('shadow.color', newHex?.toUpperCase?.())
                              }
                              disabled={
                                primaryMenuTextsettings?.globalSettings?.shadow?.color ===
                                'transparent'
                              }
                              // size="small"
                              isAlphaHidden={true} // This disables the alpha slider
                              sx={{
                                '& .MuiOutlinedInput-root': {
                                  borderRadius: '0px !important',
                                  height: 53,
                                },
                                '& .MuiOutlinedInput-input': {
                                  height: '36px',
                                },
                                '& .MuiColorInput-Button': {
                                  width: '49px !important', // Increase width
                                  height: '40px !important',
                                },
                                '& .MuiInputAdornment-root .MuiBox-root': {
                                  width: 18,
                                  height: 18,
                                },
                              }}
                            />

                            {/* <input
                              type="color"
                              disabled={primaryMenuTextsettings?.globalSettings?.shadow?.color === "transparent"}
                              value={
                                primaryMenuTextsettings?.globalSettings?.shadow?.color || "#000000"
                              }
                              onChange={(e) => handleChangePrimaryText('shadow.color', e.target.value)}
                              className="form-control"
                            /> */}
                          </div>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-md-6">
                          <button
                            style={{ backgroundColor: buttonColor }}
                            type="submit"
                            onClick={handleSubmitPage}
                          >
                            Submit
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                </>
              )}

              {value === 4 && (
                <ButtonNavigations
                  btnId={id}
                  userId={userId}
                  buttonColor={buttonColor}
                  isFrontend={isFrontend}
                  parentMenuID={parentMenuID}
                  linkbtnId={linkbtnId}
                  linkedTriviaa={linkedTrivia}
                  mainMeuLinked={mainMeuLinked}
                  linkedWayfinder={linkedWayfinder}
                />
              )}
            </Box>
          </Box>
        </div>
      </div>
    </div>
  );
};

export default ButtonSettingsForm;

// MediaDropzone Component
const MediaDropzone = ({ onDrop, selectedFile }) => {
  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    accept: {
      'image/*': ['.jpeg', '.jpg', '.png', '.gif'],
      'video/*': ['.mp4', '.mov', '.mp3'],
      'application/pdf': ['.pdf'],
    },
    multiple: false,
  });

  return (
    <div
      {...getRootProps()}
      style={{
        border: '2px dashed #cccccc',
        padding: '40px',
        borderRadius: '5px',
        textAlign: 'center',
        cursor: 'pointer',
      }}
    >
      <input {...getInputProps()} />
      {selectedFile ? (
        <p>{selectedFile.name}</p>
      ) : (
        <p>Drag and drop a file here, or click to select a file</p>
      )}
    </div>
  );
};

// UploadButton Component
const UploadButton = ({ uploading, onUpload, buttonColor, ...props }) => (
  <button
    type="button"
    onClick={onUpload}
    style={{
      marginTop: '5px',
      //   padding: "10px 20px",
      backgroundColor: buttonColor,
      color: '#FFFFFF',
      border: 'none',
      borderRadius: '5px',
      cursor: 'pointer',
      ...props.style,
    }}
    disabled={uploading}
  >
    {uploading ? 'Uploading...' : 'Upload'}
  </button>
);

const getFileType = fileUrl => {
  if (!fileUrl) return 'blank'; // No URL provided

  const imageExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.bmp', '.svg'];
  const videoExtensions = ['.mp4', '.mov', '.avi', '.mkv', '.webm'];

  if (imageExtensions.some(ext => fileUrl.toLowerCase().endsWith(ext))) {
    return 'image';
  }
  if (videoExtensions.some(ext => fileUrl.toLowerCase().endsWith(ext))) {
    return 'video';
  }
  return 'other'; // Other file types or unsupported extensions
};

// UploadedUrl Component
const UploadedUrl = ({ url, buttonColor, deleteFile }) =>
  url ? (
    <div
      style={{
        marginTop: '20px',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'flex-start', // Adjust alignment of child elements (optional)
        gap: '10px', // Add spacing between child elements (optional)
      }}
    >
      <div style={{ float: 'left', width: '100%', marginTop: '5px', overflow: 'auto' }}>
        <span style={{ fontWeight: '600', marginRight: '5px' }}> Uploaded File:</span>
        <a
          href={url.fileUrl}
          style={{ fontWeight: 'bold' }}
          target="_blank"
          rel="noopener noreferrer"
        >
          {url.fileName}
        </a>{' '}
        {url.fileName ? (
          <i
            class="dw dw-delete-3"
            style={{ fontSize: '18px', color: buttonColor, cursor: 'pointer' }}
            onClick={deleteFile}
          ></i>
        ) : (
          ''
        )}
      </div>
      <div style={{ float: 'right', width: '30%', textAlign: 'right', display: 'none' }}>
        {getFileType(url.fileUrl) === 'image' ? (
          // Render image if it's an image file
          <a href={url.fileUrl} target="_blank" rel="noreferrer">
            <img src={url.fileUrl} style={{ maxWidth: '200px', maxHeight: '60px' }} alt="" />
          </a>
        ) : getFileType(url.fileUrl) === 'video' ? (
          // Render play button for video file
          <a href={url.fileUrl} target="_blank" rel="noreferrer">
            <img
              src="https://paulavatar.s3.us-east-2.amazonaws.com/play-button.png"
              style={{ maxWidth: '200px', maxHeight: '60px' }}
              alt="Play Video"
            />
          </a>
        ) : (
          // Fallback for other cases
          ''
        )}
      </div>
    </div>
  ) : null;

const UploadedUrlQr = ({ url }) =>
  url ? (
    <div style={{ marginTop: '20px' }}>
      <img style={{ width: '150px', padding: '10px' }} src={url} alt="img" />
    </div>
  ) : null;

const UploadedUrlImage = ({ url }) => {
  return (
    <>
      {url ? (
        <div style={{ margin: 'auto' }}>
          {getFileType(url.fileUrl) === 'image' ? (
            // Render image if it's an image file
            <a href={url.fileUrl} target="_blank" rel="noreferrer">
              <img src={url.fileUrl} style={{ maxWidth: '210px', maxHeight: '80px' }} alt="" />
            </a>
          ) : getFileType(url.fileUrl) === 'video' ? (
            // Render play button for video file
            <a href={url.fileUrl} target="_blank" rel="noreferrer">
              <img
                src="https://paulavatar.s3.us-east-2.amazonaws.com/play-button.png"
                style={{ maxWidth: '200px', maxHeight: '60px' }}
                alt="Play Video"
              />
            </a>
          ) : (
            // Fallback for other cases
            ''
          )}
        </div>
      ) : null}
    </>
  );
};







